var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.63639 150.091C5.64472 150.091 7.27279 148.46 7.27279 146.448C7.27279 144.436 5.64472 142.805 3.63639 142.805C1.62807 142.805 0 144.436 0 146.448C0 148.46 1.62807 150.091 3.63639 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8171 150.091C15.8254 150.091 17.4535 148.46 17.4535 146.448C17.4535 144.436 15.8254 142.805 13.8171 142.805C11.8087 142.805 10.1807 144.436 10.1807 146.448C10.1807 148.46 11.8087 150.091 13.8171 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.9999 150.091C26.0082 150.091 27.6363 148.46 27.6363 146.448C27.6363 144.436 26.0082 142.805 23.9999 142.805C21.9916 142.805 20.3635 144.436 20.3635 146.448C20.3635 148.46 21.9916 150.091 23.9999 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.1825 150.091C36.1909 150.091 37.8189 148.46 37.8189 146.448C37.8189 144.436 36.1909 142.805 34.1825 142.805C32.1742 142.805 30.5461 144.436 30.5461 146.448C30.5461 148.46 32.1742 150.091 34.1825 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.3634 150.091C46.3718 150.091 47.9998 148.46 47.9998 146.448C47.9998 144.436 46.3718 142.805 44.3634 142.805C42.3551 142.805 40.7271 144.436 40.7271 146.448C40.7271 148.46 42.3551 150.091 44.3634 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M54.5461 150.091C56.5544 150.091 58.1825 148.46 58.1825 146.448C58.1825 144.436 56.5544 142.805 54.5461 142.805C52.5377 142.805 50.9097 144.436 50.9097 146.448C50.9097 148.46 52.5377 150.091 54.5461 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M64.7267 150.091C66.7351 150.091 68.3631 148.46 68.3631 146.448C68.3631 144.436 66.7351 142.805 64.7267 142.805C62.7184 142.805 61.0903 144.436 61.0903 146.448C61.0903 148.46 62.7184 150.091 64.7267 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M74.9096 150.091C76.9179 150.091 78.546 148.46 78.546 146.448C78.546 144.436 76.9179 142.805 74.9096 142.805C72.9013 142.805 71.2732 144.436 71.2732 146.448C71.2732 148.46 72.9013 150.091 74.9096 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M85.0922 150.091C87.1005 150.091 88.7286 148.46 88.7286 146.448C88.7286 144.436 87.1005 142.805 85.0922 142.805C83.0839 142.805 81.4558 144.436 81.4558 146.448C81.4558 148.46 83.0839 150.091 85.0922 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M95.2731 150.091C97.2814 150.091 98.9095 148.46 98.9095 146.448C98.9095 144.436 97.2814 142.805 95.2731 142.805C93.2648 142.805 91.6367 144.436 91.6367 146.448C91.6367 148.46 93.2648 150.091 95.2731 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M105.456 150.091C107.464 150.091 109.092 148.46 109.092 146.448C109.092 144.436 107.464 142.805 105.456 142.805C103.447 142.805 101.819 144.436 101.819 146.448C101.819 148.46 103.447 150.091 105.456 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M115.636 150.091C117.645 150.091 119.273 148.46 119.273 146.448C119.273 144.436 117.645 142.805 115.636 142.805C113.628 142.805 112 144.436 112 146.448C112 148.46 113.628 150.091 115.636 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M125.819 150.091C127.828 150.091 129.456 148.46 129.456 146.448C129.456 144.436 127.828 142.805 125.819 142.805C123.811 142.805 122.183 144.436 122.183 146.448C122.183 148.46 123.811 150.091 125.819 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M136.002 150.091C138.01 150.091 139.638 148.46 139.638 146.448C139.638 144.436 138.01 142.805 136.002 142.805C133.994 142.805 132.365 144.436 132.365 146.448C132.365 148.46 133.994 150.091 136.002 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M146.183 150.091C148.191 150.091 149.819 148.46 149.819 146.448C149.819 144.436 148.191 142.805 146.183 142.805C144.174 142.805 142.546 144.436 142.546 146.448C142.546 148.46 144.174 150.091 146.183 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M156.363 150.091C158.372 150.091 160 148.46 160 146.448C160 144.436 158.372 142.805 156.363 142.805C154.355 142.805 152.727 144.436 152.727 146.448C152.727 148.46 154.355 150.091 156.363 150.091Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M3.63639 139.891C5.64472 139.891 7.27279 138.26 7.27279 136.248C7.27279 134.236 5.64472 132.605 3.63639 132.605C1.62807 132.605 0 134.236 0 136.248C0 138.26 1.62807 139.891 3.63639 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M13.8171 139.891C15.8254 139.891 17.4535 138.26 17.4535 136.248C17.4535 134.236 15.8254 132.605 13.8171 132.605C11.8087 132.605 10.1807 134.236 10.1807 136.248C10.1807 138.26 11.8087 139.891 13.8171 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M23.9999 139.891C26.0082 139.891 27.6363 138.26 27.6363 136.248C27.6363 134.236 26.0082 132.605 23.9999 132.605C21.9916 132.605 20.3635 134.236 20.3635 136.248C20.3635 138.26 21.9916 139.891 23.9999 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M34.1825 139.891C36.1909 139.891 37.8189 138.26 37.8189 136.248C37.8189 134.236 36.1909 132.605 34.1825 132.605C32.1742 132.605 30.5461 134.236 30.5461 136.248C30.5461 138.26 32.1742 139.891 34.1825 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M44.3634 139.891C46.3718 139.891 47.9998 138.26 47.9998 136.248C47.9998 134.236 46.3718 132.605 44.3634 132.605C42.3551 132.605 40.7271 134.236 40.7271 136.248C40.7271 138.26 42.3551 139.891 44.3634 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M54.5461 139.891C56.5544 139.891 58.1825 138.26 58.1825 136.248C58.1825 134.236 56.5544 132.605 54.5461 132.605C52.5377 132.605 50.9097 134.236 50.9097 136.248C50.9097 138.26 52.5377 139.891 54.5461 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M64.7267 139.891C66.7351 139.891 68.3631 138.26 68.3631 136.248C68.3631 134.236 66.7351 132.605 64.7267 132.605C62.7184 132.605 61.0903 134.236 61.0903 136.248C61.0903 138.26 62.7184 139.891 64.7267 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M74.9096 139.891C76.9179 139.891 78.546 138.26 78.546 136.248C78.546 134.236 76.9179 132.605 74.9096 132.605C72.9013 132.605 71.2732 134.236 71.2732 136.248C71.2732 138.26 72.9013 139.891 74.9096 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M85.0922 139.891C87.1005 139.891 88.7286 138.26 88.7286 136.248C88.7286 134.236 87.1005 132.605 85.0922 132.605C83.0839 132.605 81.4558 134.236 81.4558 136.248C81.4558 138.26 83.0839 139.891 85.0922 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M95.2731 139.891C97.2814 139.891 98.9095 138.26 98.9095 136.248C98.9095 134.236 97.2814 132.605 95.2731 132.605C93.2648 132.605 91.6367 134.236 91.6367 136.248C91.6367 138.26 93.2648 139.891 95.2731 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M105.456 139.891C107.464 139.891 109.092 138.26 109.092 136.248C109.092 134.236 107.464 132.605 105.456 132.605C103.447 132.605 101.819 134.236 101.819 136.248C101.819 138.26 103.447 139.891 105.456 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M115.636 139.891C117.645 139.891 119.273 138.26 119.273 136.248C119.273 134.236 117.645 132.605 115.636 132.605C113.628 132.605 112 134.236 112 136.248C112 138.26 113.628 139.891 115.636 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M125.819 139.891C127.828 139.891 129.456 138.26 129.456 136.248C129.456 134.236 127.828 132.605 125.819 132.605C123.811 132.605 122.183 134.236 122.183 136.248C122.183 138.26 123.811 139.891 125.819 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M136.002 139.891C138.01 139.891 139.638 138.26 139.638 136.248C139.638 134.236 138.01 132.605 136.002 132.605C133.994 132.605 132.365 134.236 132.365 136.248C132.365 138.26 133.994 139.891 136.002 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M146.183 139.891C148.191 139.891 149.819 138.26 149.819 136.248C149.819 134.236 148.191 132.605 146.183 132.605C144.174 132.605 142.546 134.236 142.546 136.248C142.546 138.26 144.174 139.891 146.183 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M156.363 139.891C158.372 139.891 160 138.26 160 136.248C160 134.236 158.372 132.605 156.363 132.605C154.355 132.605 152.727 134.236 152.727 136.248C152.727 138.26 154.355 139.891 156.363 139.891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M3.63615 160.001C5.64448 160.001 7.27254 158.37 7.27254 156.358C7.27254 154.346 5.64448 152.715 3.63615 152.715C1.62783 152.715 -0.000244141 154.346 -0.000244141 156.358C-0.000244141 158.37 1.62783 160.001 3.63615 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M13.8171 160.001C15.8254 160.001 17.4535 158.37 17.4535 156.358C17.4535 154.346 15.8254 152.715 13.8171 152.715C11.8087 152.715 10.1807 154.346 10.1807 156.358C10.1807 158.37 11.8087 160.001 13.8171 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M23.9999 160.001C26.0082 160.001 27.6363 158.37 27.6363 156.358C27.6363 154.346 26.0082 152.715 23.9999 152.715C21.9916 152.715 20.3635 154.346 20.3635 156.358C20.3635 158.37 21.9916 160.001 23.9999 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M34.1825 160.001C36.1909 160.001 37.8189 158.37 37.8189 156.358C37.8189 154.346 36.1909 152.715 34.1825 152.715C32.1742 152.715 30.5461 154.346 30.5461 156.358C30.5461 158.37 32.1742 160.001 34.1825 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M44.3634 160.001C46.3718 160.001 47.9998 158.37 47.9998 156.358C47.9998 154.346 46.3718 152.715 44.3634 152.715C42.3551 152.715 40.7271 154.346 40.7271 156.358C40.7271 158.37 42.3551 160.001 44.3634 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M54.5461 160.001C56.5544 160.001 58.1825 158.37 58.1825 156.358C58.1825 154.346 56.5544 152.715 54.5461 152.715C52.5377 152.715 50.9097 154.346 50.9097 156.358C50.9097 158.37 52.5377 160.001 54.5461 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M64.7267 160.001C66.7351 160.001 68.3631 158.37 68.3631 156.358C68.3631 154.346 66.7351 152.715 64.7267 152.715C62.7184 152.715 61.0903 154.346 61.0903 156.358C61.0903 158.37 62.7184 160.001 64.7267 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M74.9096 160.001C76.9179 160.001 78.546 158.37 78.546 156.358C78.546 154.346 76.9179 152.715 74.9096 152.715C72.9013 152.715 71.2732 154.346 71.2732 156.358C71.2732 158.37 72.9013 160.001 74.9096 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M85.0922 160.001C87.1005 160.001 88.7286 158.37 88.7286 156.358C88.7286 154.346 87.1005 152.715 85.0922 152.715C83.0839 152.715 81.4558 154.346 81.4558 156.358C81.4558 158.37 83.0839 160.001 85.0922 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M95.2731 160.001C97.2814 160.001 98.9095 158.37 98.9095 156.358C98.9095 154.346 97.2814 152.715 95.2731 152.715C93.2648 152.715 91.6367 154.346 91.6367 156.358C91.6367 158.37 93.2648 160.001 95.2731 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M105.456 160.001C107.464 160.001 109.092 158.37 109.092 156.358C109.092 154.346 107.464 152.715 105.456 152.715C103.447 152.715 101.819 154.346 101.819 156.358C101.819 158.37 103.447 160.001 105.456 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M115.636 160.001C117.645 160.001 119.273 158.37 119.273 156.358C119.273 154.346 117.645 152.715 115.636 152.715C113.628 152.715 112 154.346 112 156.358C112 158.37 113.628 160.001 115.636 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M125.819 160.001C127.828 160.001 129.456 158.37 129.456 156.358C129.456 154.346 127.828 152.715 125.819 152.715C123.811 152.715 122.183 154.346 122.183 156.358C122.183 158.37 123.811 160.001 125.819 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M136.002 160.001C138.01 160.001 139.638 158.37 139.638 156.358C139.638 154.346 138.01 152.715 136.002 152.715C133.994 152.715 132.365 154.346 132.365 156.358C132.365 158.37 133.994 160.001 136.002 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M146.183 160.001C148.191 160.001 149.819 158.37 149.819 156.358C149.819 154.346 148.191 152.715 146.183 152.715C144.174 152.715 142.546 154.346 142.546 156.358C142.546 158.37 144.174 160.001 146.183 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M156.363 160.001C158.372 160.001 160 158.37 160 156.358C160 154.346 158.372 152.715 156.363 152.715C154.355 152.715 152.727 154.346 152.727 156.358C152.727 158.37 154.355 160.001 156.363 160.001Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M3.63615 129.692C5.64448 129.692 7.27254 128.061 7.27254 126.049C7.27254 124.037 5.64448 122.406 3.63615 122.406C1.62783 122.406 -0.000244141 124.037 -0.000244141 126.049C-0.000244141 128.061 1.62783 129.692 3.63615 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M13.8171 129.692C15.8254 129.692 17.4535 128.061 17.4535 126.049C17.4535 124.037 15.8254 122.406 13.8171 122.406C11.8087 122.406 10.1807 124.037 10.1807 126.049C10.1807 128.061 11.8087 129.692 13.8171 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M23.9999 129.692C26.0082 129.692 27.6363 128.061 27.6363 126.049C27.6363 124.037 26.0082 122.406 23.9999 122.406C21.9916 122.406 20.3635 124.037 20.3635 126.049C20.3635 128.061 21.9916 129.692 23.9999 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M34.1825 129.692C36.1909 129.692 37.8189 128.061 37.8189 126.049C37.8189 124.037 36.1909 122.406 34.1825 122.406C32.1742 122.406 30.5461 124.037 30.5461 126.049C30.5461 128.061 32.1742 129.692 34.1825 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M44.3634 129.692C46.3718 129.692 47.9998 128.061 47.9998 126.049C47.9998 124.037 46.3718 122.406 44.3634 122.406C42.3551 122.406 40.7271 124.037 40.7271 126.049C40.7271 128.061 42.3551 129.692 44.3634 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M54.5461 129.692C56.5544 129.692 58.1825 128.061 58.1825 126.049C58.1825 124.037 56.5544 122.406 54.5461 122.406C52.5377 122.406 50.9097 124.037 50.9097 126.049C50.9097 128.061 52.5377 129.692 54.5461 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M64.7267 129.692C66.7351 129.692 68.3631 128.061 68.3631 126.049C68.3631 124.037 66.7351 122.406 64.7267 122.406C62.7184 122.406 61.0903 124.037 61.0903 126.049C61.0903 128.061 62.7184 129.692 64.7267 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M74.9096 129.692C76.9179 129.692 78.546 128.061 78.546 126.049C78.546 124.037 76.9179 122.406 74.9096 122.406C72.9013 122.406 71.2732 124.037 71.2732 126.049C71.2732 128.061 72.9013 129.692 74.9096 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M85.0922 129.692C87.1005 129.692 88.7286 128.061 88.7286 126.049C88.7286 124.037 87.1005 122.406 85.0922 122.406C83.0839 122.406 81.4558 124.037 81.4558 126.049C81.4558 128.061 83.0839 129.692 85.0922 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M95.2731 129.692C97.2814 129.692 98.9095 128.061 98.9095 126.049C98.9095 124.037 97.2814 122.406 95.2731 122.406C93.2648 122.406 91.6367 124.037 91.6367 126.049C91.6367 128.061 93.2648 129.692 95.2731 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M105.456 129.692C107.464 129.692 109.092 128.061 109.092 126.049C109.092 124.037 107.464 122.406 105.456 122.406C103.447 122.406 101.819 124.037 101.819 126.049C101.819 128.061 103.447 129.692 105.456 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M115.636 129.692C117.645 129.692 119.273 128.061 119.273 126.049C119.273 124.037 117.645 122.406 115.636 122.406C113.628 122.406 112 124.037 112 126.049C112 128.061 113.628 129.692 115.636 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M125.819 129.692C127.828 129.692 129.456 128.061 129.456 126.049C129.456 124.037 127.828 122.406 125.819 122.406C123.811 122.406 122.183 124.037 122.183 126.049C122.183 128.061 123.811 129.692 125.819 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M136.002 129.692C138.01 129.692 139.638 128.061 139.638 126.049C139.638 124.037 138.01 122.406 136.002 122.406C133.994 122.406 132.365 124.037 132.365 126.049C132.365 128.061 133.994 129.692 136.002 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M146.183 129.692C148.191 129.692 149.819 128.061 149.819 126.049C149.819 124.037 148.191 122.406 146.183 122.406C144.174 122.406 142.546 124.037 142.546 126.049C142.546 128.061 144.174 129.692 146.183 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M156.363 129.692C158.372 129.692 160 128.061 160 126.049C160 124.037 158.372 122.406 156.363 122.406C154.355 122.406 152.727 124.037 152.727 126.049C152.727 128.061 154.355 129.692 156.363 129.692Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M3.63615 119.489C5.64448 119.489 7.27254 117.858 7.27254 115.846C7.27254 113.834 5.64448 112.203 3.63615 112.203C1.62783 112.203 -0.000244141 113.834 -0.000244141 115.846C-0.000244141 117.858 1.62783 119.489 3.63615 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M13.8171 119.489C15.8254 119.489 17.4535 117.858 17.4535 115.846C17.4535 113.834 15.8254 112.203 13.8171 112.203C11.8087 112.203 10.1807 113.834 10.1807 115.846C10.1807 117.858 11.8087 119.489 13.8171 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M23.9999 119.489C26.0082 119.489 27.6363 117.858 27.6363 115.846C27.6363 113.834 26.0082 112.203 23.9999 112.203C21.9916 112.203 20.3635 113.834 20.3635 115.846C20.3635 117.858 21.9916 119.489 23.9999 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M34.1825 119.489C36.1909 119.489 37.8189 117.858 37.8189 115.846C37.8189 113.834 36.1909 112.203 34.1825 112.203C32.1742 112.203 30.5461 113.834 30.5461 115.846C30.5461 117.858 32.1742 119.489 34.1825 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M44.3634 119.489C46.3718 119.489 47.9998 117.858 47.9998 115.846C47.9998 113.834 46.3718 112.203 44.3634 112.203C42.3551 112.203 40.7271 113.834 40.7271 115.846C40.7271 117.858 42.3551 119.489 44.3634 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M54.5461 119.489C56.5544 119.489 58.1825 117.858 58.1825 115.846C58.1825 113.834 56.5544 112.203 54.5461 112.203C52.5377 112.203 50.9097 113.834 50.9097 115.846C50.9097 117.858 52.5377 119.489 54.5461 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M64.7267 119.489C66.7351 119.489 68.3631 117.858 68.3631 115.846C68.3631 113.834 66.7351 112.203 64.7267 112.203C62.7184 112.203 61.0903 113.834 61.0903 115.846C61.0903 117.858 62.7184 119.489 64.7267 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M74.9096 119.489C76.9179 119.489 78.546 117.858 78.546 115.846C78.546 113.834 76.9179 112.203 74.9096 112.203C72.9013 112.203 71.2732 113.834 71.2732 115.846C71.2732 117.858 72.9013 119.489 74.9096 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M85.0922 119.489C87.1005 119.489 88.7286 117.858 88.7286 115.846C88.7286 113.834 87.1005 112.203 85.0922 112.203C83.0839 112.203 81.4558 113.834 81.4558 115.846C81.4558 117.858 83.0839 119.489 85.0922 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M95.2731 119.489C97.2814 119.489 98.9095 117.858 98.9095 115.846C98.9095 113.834 97.2814 112.203 95.2731 112.203C93.2648 112.203 91.6367 113.834 91.6367 115.846C91.6367 117.858 93.2648 119.489 95.2731 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M105.456 119.489C107.464 119.489 109.092 117.858 109.092 115.846C109.092 113.834 107.464 112.203 105.456 112.203C103.447 112.203 101.819 113.834 101.819 115.846C101.819 117.858 103.447 119.489 105.456 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M115.636 119.489C117.645 119.489 119.273 117.858 119.273 115.846C119.273 113.834 117.645 112.203 115.636 112.203C113.628 112.203 112 113.834 112 115.846C112 117.858 113.628 119.489 115.636 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M125.819 119.489C127.828 119.489 129.456 117.858 129.456 115.846C129.456 113.834 127.828 112.203 125.819 112.203C123.811 112.203 122.183 113.834 122.183 115.846C122.183 117.858 123.811 119.489 125.819 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M136.002 119.489C138.01 119.489 139.638 117.858 139.638 115.846C139.638 113.834 138.01 112.203 136.002 112.203C133.994 112.203 132.365 113.834 132.365 115.846C132.365 117.858 133.994 119.489 136.002 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M146.183 119.489C148.191 119.489 149.819 117.858 149.819 115.846C149.819 113.834 148.191 112.203 146.183 112.203C144.174 112.203 142.546 113.834 142.546 115.846C142.546 117.858 144.174 119.489 146.183 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M156.363 119.489C158.372 119.489 160 117.858 160 115.846C160 113.834 158.372 112.203 156.363 112.203C154.355 112.203 152.727 113.834 152.727 115.846C152.727 117.858 154.355 119.489 156.363 119.489Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M3.63639 109.29C5.64472 109.29 7.27279 107.659 7.27279 105.647C7.27279 103.635 5.64472 102.004 3.63639 102.004C1.62807 102.004 0 103.635 0 105.647C0 107.659 1.62807 109.29 3.63639 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M13.8171 109.29C15.8254 109.29 17.4535 107.659 17.4535 105.647C17.4535 103.635 15.8254 102.004 13.8171 102.004C11.8087 102.004 10.1807 103.635 10.1807 105.647C10.1807 107.659 11.8087 109.29 13.8171 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M23.9999 109.29C26.0082 109.29 27.6363 107.659 27.6363 105.647C27.6363 103.635 26.0082 102.004 23.9999 102.004C21.9916 102.004 20.3635 103.635 20.3635 105.647C20.3635 107.659 21.9916 109.29 23.9999 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M34.1825 109.29C36.1909 109.29 37.8189 107.659 37.8189 105.647C37.8189 103.635 36.1909 102.004 34.1825 102.004C32.1742 102.004 30.5461 103.635 30.5461 105.647C30.5461 107.659 32.1742 109.29 34.1825 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M44.3634 109.29C46.3718 109.29 47.9998 107.659 47.9998 105.647C47.9998 103.635 46.3718 102.004 44.3634 102.004C42.3551 102.004 40.7271 103.635 40.7271 105.647C40.7271 107.659 42.3551 109.29 44.3634 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M54.5461 109.29C56.5544 109.29 58.1825 107.659 58.1825 105.647C58.1825 103.635 56.5544 102.004 54.5461 102.004C52.5377 102.004 50.9097 103.635 50.9097 105.647C50.9097 107.659 52.5377 109.29 54.5461 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M64.7267 109.29C66.7351 109.29 68.3631 107.659 68.3631 105.647C68.3631 103.635 66.7351 102.004 64.7267 102.004C62.7184 102.004 61.0903 103.635 61.0903 105.647C61.0903 107.659 62.7184 109.29 64.7267 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M74.9096 109.29C76.9179 109.29 78.546 107.659 78.546 105.647C78.546 103.635 76.9179 102.004 74.9096 102.004C72.9013 102.004 71.2732 103.635 71.2732 105.647C71.2732 107.659 72.9013 109.29 74.9096 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M85.0922 109.29C87.1005 109.29 88.7286 107.659 88.7286 105.647C88.7286 103.635 87.1005 102.004 85.0922 102.004C83.0839 102.004 81.4558 103.635 81.4558 105.647C81.4558 107.659 83.0839 109.29 85.0922 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M95.2731 109.29C97.2814 109.29 98.9095 107.659 98.9095 105.647C98.9095 103.635 97.2814 102.004 95.2731 102.004C93.2648 102.004 91.6367 103.635 91.6367 105.647C91.6367 107.659 93.2648 109.29 95.2731 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M105.456 109.29C107.464 109.29 109.092 107.659 109.092 105.647C109.092 103.635 107.464 102.004 105.456 102.004C103.447 102.004 101.819 103.635 101.819 105.647C101.819 107.659 103.447 109.29 105.456 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M115.636 109.29C117.645 109.29 119.273 107.659 119.273 105.647C119.273 103.635 117.645 102.004 115.636 102.004C113.628 102.004 112 103.635 112 105.647C112 107.659 113.628 109.29 115.636 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M125.819 109.29C127.828 109.29 129.456 107.659 129.456 105.647C129.456 103.635 127.828 102.004 125.819 102.004C123.811 102.004 122.183 103.635 122.183 105.647C122.183 107.659 123.811 109.29 125.819 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M136.002 109.29C138.01 109.29 139.638 107.659 139.638 105.647C139.638 103.635 138.01 102.004 136.002 102.004C133.994 102.004 132.365 103.635 132.365 105.647C132.365 107.659 133.994 109.29 136.002 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M146.183 109.29C148.191 109.29 149.819 107.659 149.819 105.647C149.819 103.635 148.191 102.004 146.183 102.004C144.174 102.004 142.546 103.635 142.546 105.647C142.546 107.659 144.174 109.29 146.183 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M156.363 109.29C158.372 109.29 160 107.659 160 105.647C160 103.635 158.372 102.004 156.363 102.004C154.355 102.004 152.727 103.635 152.727 105.647C152.727 107.659 154.355 109.29 156.363 109.29Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M3.63639 99.0907C5.64472 99.0907 7.27279 97.4596 7.27279 95.4477C7.27279 93.4357 5.64472 91.8047 3.63639 91.8047C1.62807 91.8047 0 93.4357 0 95.4477C0 97.4596 1.62807 99.0907 3.63639 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M13.8171 99.0907C15.8254 99.0907 17.4535 97.4596 17.4535 95.4477C17.4535 93.4357 15.8254 91.8047 13.8171 91.8047C11.8087 91.8047 10.1807 93.4357 10.1807 95.4477C10.1807 97.4596 11.8087 99.0907 13.8171 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M23.9999 99.0907C26.0082 99.0907 27.6363 97.4596 27.6363 95.4477C27.6363 93.4357 26.0082 91.8047 23.9999 91.8047C21.9916 91.8047 20.3635 93.4357 20.3635 95.4477C20.3635 97.4596 21.9916 99.0907 23.9999 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M34.1825 99.0907C36.1909 99.0907 37.8189 97.4596 37.8189 95.4477C37.8189 93.4357 36.1909 91.8047 34.1825 91.8047C32.1742 91.8047 30.5461 93.4357 30.5461 95.4477C30.5461 97.4596 32.1742 99.0907 34.1825 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M44.3634 99.0907C46.3718 99.0907 47.9998 97.4596 47.9998 95.4477C47.9998 93.4357 46.3718 91.8047 44.3634 91.8047C42.3551 91.8047 40.7271 93.4357 40.7271 95.4477C40.7271 97.4596 42.3551 99.0907 44.3634 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M54.5461 99.0907C56.5544 99.0907 58.1825 97.4596 58.1825 95.4477C58.1825 93.4357 56.5544 91.8047 54.5461 91.8047C52.5377 91.8047 50.9097 93.4357 50.9097 95.4477C50.9097 97.4596 52.5377 99.0907 54.5461 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M64.7267 99.0907C66.7351 99.0907 68.3631 97.4596 68.3631 95.4477C68.3631 93.4357 66.7351 91.8047 64.7267 91.8047C62.7184 91.8047 61.0903 93.4357 61.0903 95.4477C61.0903 97.4596 62.7184 99.0907 64.7267 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M74.9096 99.0907C76.9179 99.0907 78.546 97.4596 78.546 95.4477C78.546 93.4357 76.9179 91.8047 74.9096 91.8047C72.9013 91.8047 71.2732 93.4357 71.2732 95.4477C71.2732 97.4596 72.9013 99.0907 74.9096 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M85.0922 99.0907C87.1005 99.0907 88.7286 97.4596 88.7286 95.4477C88.7286 93.4357 87.1005 91.8047 85.0922 91.8047C83.0839 91.8047 81.4558 93.4357 81.4558 95.4477C81.4558 97.4596 83.0839 99.0907 85.0922 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M95.2731 99.0907C97.2814 99.0907 98.9095 97.4596 98.9095 95.4477C98.9095 93.4357 97.2814 91.8047 95.2731 91.8047C93.2648 91.8047 91.6367 93.4357 91.6367 95.4477C91.6367 97.4596 93.2648 99.0907 95.2731 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M105.456 99.0907C107.464 99.0907 109.092 97.4596 109.092 95.4477C109.092 93.4357 107.464 91.8047 105.456 91.8047C103.447 91.8047 101.819 93.4357 101.819 95.4477C101.819 97.4596 103.447 99.0907 105.456 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M115.636 99.0907C117.645 99.0907 119.273 97.4596 119.273 95.4477C119.273 93.4357 117.645 91.8047 115.636 91.8047C113.628 91.8047 112 93.4357 112 95.4477C112 97.4596 113.628 99.0907 115.636 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M125.819 99.0907C127.828 99.0907 129.456 97.4596 129.456 95.4477C129.456 93.4357 127.828 91.8047 125.819 91.8047C123.811 91.8047 122.183 93.4357 122.183 95.4477C122.183 97.4596 123.811 99.0907 125.819 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M136.002 99.0907C138.01 99.0907 139.638 97.4596 139.638 95.4477C139.638 93.4357 138.01 91.8047 136.002 91.8047C133.994 91.8047 132.365 93.4357 132.365 95.4477C132.365 97.4596 133.994 99.0907 136.002 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M146.183 99.0907C148.191 99.0907 149.819 97.4596 149.819 95.4477C149.819 93.4357 148.191 91.8047 146.183 91.8047C144.174 91.8047 142.546 93.4357 142.546 95.4477C142.546 97.4596 144.174 99.0907 146.183 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M156.363 99.0907C158.372 99.0907 160 97.4596 160 95.4477C160 93.4357 158.372 91.8047 156.363 91.8047C154.355 91.8047 152.727 93.4357 152.727 95.4477C152.727 97.4596 154.355 99.0907 156.363 99.0907Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M3.63639 88.8875C5.64472 88.8875 7.27279 87.2565 7.27279 85.2445C7.27279 83.2326 5.64472 81.6016 3.63639 81.6016C1.62807 81.6016 0 83.2326 0 85.2445C0 87.2565 1.62807 88.8875 3.63639 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M13.8171 88.8875C15.8254 88.8875 17.4535 87.2565 17.4535 85.2445C17.4535 83.2326 15.8254 81.6016 13.8171 81.6016C11.8087 81.6016 10.1807 83.2326 10.1807 85.2445C10.1807 87.2565 11.8087 88.8875 13.8171 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M23.9999 88.8875C26.0082 88.8875 27.6363 87.2565 27.6363 85.2445C27.6363 83.2326 26.0082 81.6016 23.9999 81.6016C21.9916 81.6016 20.3635 83.2326 20.3635 85.2445C20.3635 87.2565 21.9916 88.8875 23.9999 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M34.1825 88.8875C36.1909 88.8875 37.8189 87.2565 37.8189 85.2445C37.8189 83.2326 36.1909 81.6016 34.1825 81.6016C32.1742 81.6016 30.5461 83.2326 30.5461 85.2445C30.5461 87.2565 32.1742 88.8875 34.1825 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M44.3634 88.8875C46.3718 88.8875 47.9998 87.2565 47.9998 85.2445C47.9998 83.2326 46.3718 81.6016 44.3634 81.6016C42.3551 81.6016 40.7271 83.2326 40.7271 85.2445C40.7271 87.2565 42.3551 88.8875 44.3634 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M54.5461 88.8875C56.5544 88.8875 58.1825 87.2565 58.1825 85.2445C58.1825 83.2326 56.5544 81.6016 54.5461 81.6016C52.5377 81.6016 50.9097 83.2326 50.9097 85.2445C50.9097 87.2565 52.5377 88.8875 54.5461 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M64.7267 88.8875C66.7351 88.8875 68.3631 87.2565 68.3631 85.2445C68.3631 83.2326 66.7351 81.6016 64.7267 81.6016C62.7184 81.6016 61.0903 83.2326 61.0903 85.2445C61.0903 87.2565 62.7184 88.8875 64.7267 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M74.9096 88.8875C76.9179 88.8875 78.546 87.2565 78.546 85.2445C78.546 83.2326 76.9179 81.6016 74.9096 81.6016C72.9013 81.6016 71.2732 83.2326 71.2732 85.2445C71.2732 87.2565 72.9013 88.8875 74.9096 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M85.0922 88.8875C87.1005 88.8875 88.7286 87.2565 88.7286 85.2445C88.7286 83.2326 87.1005 81.6016 85.0922 81.6016C83.0839 81.6016 81.4558 83.2326 81.4558 85.2445C81.4558 87.2565 83.0839 88.8875 85.0922 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M95.2731 88.8875C97.2814 88.8875 98.9095 87.2565 98.9095 85.2445C98.9095 83.2326 97.2814 81.6016 95.2731 81.6016C93.2648 81.6016 91.6367 83.2326 91.6367 85.2445C91.6367 87.2565 93.2648 88.8875 95.2731 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M105.456 88.8875C107.464 88.8875 109.092 87.2565 109.092 85.2445C109.092 83.2326 107.464 81.6016 105.456 81.6016C103.447 81.6016 101.819 83.2326 101.819 85.2445C101.819 87.2565 103.447 88.8875 105.456 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M115.636 88.8875C117.645 88.8875 119.273 87.2565 119.273 85.2445C119.273 83.2326 117.645 81.6016 115.636 81.6016C113.628 81.6016 112 83.2326 112 85.2445C112 87.2565 113.628 88.8875 115.636 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M125.819 88.8875C127.828 88.8875 129.456 87.2565 129.456 85.2445C129.456 83.2326 127.828 81.6016 125.819 81.6016C123.811 81.6016 122.183 83.2326 122.183 85.2445C122.183 87.2565 123.811 88.8875 125.819 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M136.002 88.8875C138.01 88.8875 139.638 87.2565 139.638 85.2445C139.638 83.2326 138.01 81.6016 136.002 81.6016C133.994 81.6016 132.365 83.2326 132.365 85.2445C132.365 87.2565 133.994 88.8875 136.002 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M146.183 88.8875C148.191 88.8875 149.819 87.2565 149.819 85.2445C149.819 83.2326 148.191 81.6016 146.183 81.6016C144.174 81.6016 142.546 83.2326 142.546 85.2445C142.546 87.2565 144.174 88.8875 146.183 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M156.363 88.8875C158.372 88.8875 160 87.2565 160 85.2445C160 83.2326 158.372 81.6016 156.363 81.6016C154.355 81.6016 152.727 83.2326 152.727 85.2445C152.727 87.2565 154.355 88.8875 156.363 88.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M3.63615 78.6883C5.64448 78.6883 7.27254 77.0573 7.27254 75.0453C7.27254 73.0334 5.64448 71.4023 3.63615 71.4023C1.62783 71.4023 -0.000244141 73.0334 -0.000244141 75.0453C-0.000244141 77.0573 1.62783 78.6883 3.63615 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M13.8171 78.6883C15.8254 78.6883 17.4535 77.0573 17.4535 75.0453C17.4535 73.0334 15.8254 71.4023 13.8171 71.4023C11.8087 71.4023 10.1807 73.0334 10.1807 75.0453C10.1807 77.0573 11.8087 78.6883 13.8171 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M23.9999 78.6883C26.0082 78.6883 27.6363 77.0573 27.6363 75.0453C27.6363 73.0334 26.0082 71.4023 23.9999 71.4023C21.9916 71.4023 20.3635 73.0334 20.3635 75.0453C20.3635 77.0573 21.9916 78.6883 23.9999 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M34.1825 78.6883C36.1909 78.6883 37.8189 77.0573 37.8189 75.0453C37.8189 73.0334 36.1909 71.4023 34.1825 71.4023C32.1742 71.4023 30.5461 73.0334 30.5461 75.0453C30.5461 77.0573 32.1742 78.6883 34.1825 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M44.3634 78.6883C46.3718 78.6883 47.9998 77.0573 47.9998 75.0453C47.9998 73.0334 46.3718 71.4023 44.3634 71.4023C42.3551 71.4023 40.7271 73.0334 40.7271 75.0453C40.7271 77.0573 42.3551 78.6883 44.3634 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M54.5461 78.6883C56.5544 78.6883 58.1825 77.0573 58.1825 75.0453C58.1825 73.0334 56.5544 71.4023 54.5461 71.4023C52.5377 71.4023 50.9097 73.0334 50.9097 75.0453C50.9097 77.0573 52.5377 78.6883 54.5461 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M64.7267 78.6883C66.7351 78.6883 68.3631 77.0573 68.3631 75.0453C68.3631 73.0334 66.7351 71.4023 64.7267 71.4023C62.7184 71.4023 61.0903 73.0334 61.0903 75.0453C61.0903 77.0573 62.7184 78.6883 64.7267 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M74.9096 78.6883C76.9179 78.6883 78.546 77.0573 78.546 75.0453C78.546 73.0334 76.9179 71.4023 74.9096 71.4023C72.9013 71.4023 71.2732 73.0334 71.2732 75.0453C71.2732 77.0573 72.9013 78.6883 74.9096 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M85.0922 78.6883C87.1005 78.6883 88.7286 77.0573 88.7286 75.0453C88.7286 73.0334 87.1005 71.4023 85.0922 71.4023C83.0839 71.4023 81.4558 73.0334 81.4558 75.0453C81.4558 77.0573 83.0839 78.6883 85.0922 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M95.2731 78.6883C97.2814 78.6883 98.9095 77.0573 98.9095 75.0453C98.9095 73.0334 97.2814 71.4023 95.2731 71.4023C93.2648 71.4023 91.6367 73.0334 91.6367 75.0453C91.6367 77.0573 93.2648 78.6883 95.2731 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M105.456 78.6883C107.464 78.6883 109.092 77.0573 109.092 75.0453C109.092 73.0334 107.464 71.4023 105.456 71.4023C103.447 71.4023 101.819 73.0334 101.819 75.0453C101.819 77.0573 103.447 78.6883 105.456 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M115.636 78.6883C117.645 78.6883 119.273 77.0573 119.273 75.0453C119.273 73.0334 117.645 71.4023 115.636 71.4023C113.628 71.4023 112 73.0334 112 75.0453C112 77.0573 113.628 78.6883 115.636 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M125.819 78.6883C127.828 78.6883 129.456 77.0573 129.456 75.0453C129.456 73.0334 127.828 71.4023 125.819 71.4023C123.811 71.4023 122.183 73.0334 122.183 75.0453C122.183 77.0573 123.811 78.6883 125.819 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M136.002 78.6883C138.01 78.6883 139.638 77.0573 139.638 75.0453C139.638 73.0334 138.01 71.4023 136.002 71.4023C133.994 71.4023 132.365 73.0334 132.365 75.0453C132.365 77.0573 133.994 78.6883 136.002 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M146.183 78.6883C148.191 78.6883 149.819 77.0573 149.819 75.0453C149.819 73.0334 148.191 71.4023 146.183 71.4023C144.174 71.4023 142.546 73.0334 142.546 75.0453C142.546 77.0573 144.174 78.6883 146.183 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M156.363 78.6883C158.372 78.6883 160 77.0573 160 75.0453C160 73.0334 158.372 71.4023 156.363 71.4023C154.355 71.4023 152.727 73.0334 152.727 75.0453C152.727 77.0573 154.355 78.6883 156.363 78.6883Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M3.63615 68.4891C5.64448 68.4891 7.27254 66.8581 7.27254 64.8461C7.27254 62.8341 5.64448 61.2031 3.63615 61.2031C1.62783 61.2031 -0.000244141 62.8341 -0.000244141 64.8461C-0.000244141 66.8581 1.62783 68.4891 3.63615 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M13.8171 68.4891C15.8254 68.4891 17.4535 66.8581 17.4535 64.8461C17.4535 62.8341 15.8254 61.2031 13.8171 61.2031C11.8087 61.2031 10.1807 62.8341 10.1807 64.8461C10.1807 66.8581 11.8087 68.4891 13.8171 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M23.9999 68.4891C26.0082 68.4891 27.6363 66.8581 27.6363 64.8461C27.6363 62.8341 26.0082 61.2031 23.9999 61.2031C21.9916 61.2031 20.3635 62.8341 20.3635 64.8461C20.3635 66.8581 21.9916 68.4891 23.9999 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M34.1825 68.4891C36.1909 68.4891 37.8189 66.8581 37.8189 64.8461C37.8189 62.8341 36.1909 61.2031 34.1825 61.2031C32.1742 61.2031 30.5461 62.8341 30.5461 64.8461C30.5461 66.8581 32.1742 68.4891 34.1825 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M44.3634 68.4891C46.3718 68.4891 47.9998 66.8581 47.9998 64.8461C47.9998 62.8341 46.3718 61.2031 44.3634 61.2031C42.3551 61.2031 40.7271 62.8341 40.7271 64.8461C40.7271 66.8581 42.3551 68.4891 44.3634 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M54.5461 68.4891C56.5544 68.4891 58.1825 66.8581 58.1825 64.8461C58.1825 62.8341 56.5544 61.2031 54.5461 61.2031C52.5377 61.2031 50.9097 62.8341 50.9097 64.8461C50.9097 66.8581 52.5377 68.4891 54.5461 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M64.7267 68.4891C66.7351 68.4891 68.3631 66.8581 68.3631 64.8461C68.3631 62.8341 66.7351 61.2031 64.7267 61.2031C62.7184 61.2031 61.0903 62.8341 61.0903 64.8461C61.0903 66.8581 62.7184 68.4891 64.7267 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M74.9096 68.4891C76.9179 68.4891 78.546 66.8581 78.546 64.8461C78.546 62.8341 76.9179 61.2031 74.9096 61.2031C72.9013 61.2031 71.2732 62.8341 71.2732 64.8461C71.2732 66.8581 72.9013 68.4891 74.9096 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M85.0922 68.4891C87.1005 68.4891 88.7286 66.8581 88.7286 64.8461C88.7286 62.8341 87.1005 61.2031 85.0922 61.2031C83.0839 61.2031 81.4558 62.8341 81.4558 64.8461C81.4558 66.8581 83.0839 68.4891 85.0922 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M95.2731 68.4891C97.2814 68.4891 98.9095 66.8581 98.9095 64.8461C98.9095 62.8341 97.2814 61.2031 95.2731 61.2031C93.2648 61.2031 91.6367 62.8341 91.6367 64.8461C91.6367 66.8581 93.2648 68.4891 95.2731 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M105.456 68.4891C107.464 68.4891 109.092 66.8581 109.092 64.8461C109.092 62.8341 107.464 61.2031 105.456 61.2031C103.447 61.2031 101.819 62.8341 101.819 64.8461C101.819 66.8581 103.447 68.4891 105.456 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M115.636 68.4891C117.645 68.4891 119.273 66.8581 119.273 64.8461C119.273 62.8341 117.645 61.2031 115.636 61.2031C113.628 61.2031 112 62.8341 112 64.8461C112 66.8581 113.628 68.4891 115.636 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M125.819 68.4891C127.828 68.4891 129.456 66.8581 129.456 64.8461C129.456 62.8341 127.828 61.2031 125.819 61.2031C123.811 61.2031 122.183 62.8341 122.183 64.8461C122.183 66.8581 123.811 68.4891 125.819 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M136.002 68.4891C138.01 68.4891 139.638 66.8581 139.638 64.8461C139.638 62.8341 138.01 61.2031 136.002 61.2031C133.994 61.2031 132.365 62.8341 132.365 64.8461C132.365 66.8581 133.994 68.4891 136.002 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M146.183 68.4891C148.191 68.4891 149.819 66.8581 149.819 64.8461C149.819 62.8341 148.191 61.2031 146.183 61.2031C144.174 61.2031 142.546 62.8341 142.546 64.8461C142.546 66.8581 144.174 68.4891 146.183 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M156.363 68.4891C158.372 68.4891 160 66.8581 160 64.8461C160 62.8341 158.372 61.2031 156.363 61.2031C154.355 61.2031 152.727 62.8341 152.727 64.8461C152.727 66.8581 154.355 68.4891 156.363 68.4891Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M3.63615 58.286C5.64448 58.286 7.27254 56.655 7.27254 54.643C7.27254 52.631 5.64448 51 3.63615 51C1.62783 51 -0.000244141 52.631 -0.000244141 54.643C-0.000244141 56.655 1.62783 58.286 3.63615 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M13.8171 58.286C15.8254 58.286 17.4535 56.655 17.4535 54.643C17.4535 52.631 15.8254 51 13.8171 51C11.8087 51 10.1807 52.631 10.1807 54.643C10.1807 56.655 11.8087 58.286 13.8171 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M23.9999 58.286C26.0082 58.286 27.6363 56.655 27.6363 54.643C27.6363 52.631 26.0082 51 23.9999 51C21.9916 51 20.3635 52.631 20.3635 54.643C20.3635 56.655 21.9916 58.286 23.9999 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M34.1825 58.286C36.1909 58.286 37.8189 56.655 37.8189 54.643C37.8189 52.631 36.1909 51 34.1825 51C32.1742 51 30.5461 52.631 30.5461 54.643C30.5461 56.655 32.1742 58.286 34.1825 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M44.3634 58.286C46.3718 58.286 47.9998 56.655 47.9998 54.643C47.9998 52.631 46.3718 51 44.3634 51C42.3551 51 40.7271 52.631 40.7271 54.643C40.7271 56.655 42.3551 58.286 44.3634 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M54.5461 58.286C56.5544 58.286 58.1825 56.655 58.1825 54.643C58.1825 52.631 56.5544 51 54.5461 51C52.5377 51 50.9097 52.631 50.9097 54.643C50.9097 56.655 52.5377 58.286 54.5461 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M64.7267 58.286C66.7351 58.286 68.3631 56.655 68.3631 54.643C68.3631 52.631 66.7351 51 64.7267 51C62.7184 51 61.0903 52.631 61.0903 54.643C61.0903 56.655 62.7184 58.286 64.7267 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M74.9096 58.286C76.9179 58.286 78.546 56.655 78.546 54.643C78.546 52.631 76.9179 51 74.9096 51C72.9013 51 71.2732 52.631 71.2732 54.643C71.2732 56.655 72.9013 58.286 74.9096 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M85.0922 58.286C87.1005 58.286 88.7286 56.655 88.7286 54.643C88.7286 52.631 87.1005 51 85.0922 51C83.0839 51 81.4558 52.631 81.4558 54.643C81.4558 56.655 83.0839 58.286 85.0922 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M95.2731 58.286C97.2814 58.286 98.9095 56.655 98.9095 54.643C98.9095 52.631 97.2814 51 95.2731 51C93.2648 51 91.6367 52.631 91.6367 54.643C91.6367 56.655 93.2648 58.286 95.2731 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M105.456 58.286C107.464 58.286 109.092 56.655 109.092 54.643C109.092 52.631 107.464 51 105.456 51C103.447 51 101.819 52.631 101.819 54.643C101.819 56.655 103.447 58.286 105.456 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M115.636 58.286C117.645 58.286 119.273 56.655 119.273 54.643C119.273 52.631 117.645 51 115.636 51C113.628 51 112 52.631 112 54.643C112 56.655 113.628 58.286 115.636 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M125.819 58.286C127.828 58.286 129.456 56.655 129.456 54.643C129.456 52.631 127.828 51 125.819 51C123.811 51 122.183 52.631 122.183 54.643C122.183 56.655 123.811 58.286 125.819 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M136.002 58.286C138.01 58.286 139.638 56.655 139.638 54.643C139.638 52.631 138.01 51 136.002 51C133.994 51 132.365 52.631 132.365 54.643C132.365 56.655 133.994 58.286 136.002 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M146.183 58.286C148.191 58.286 149.819 56.655 149.819 54.643C149.819 52.631 148.191 51 146.183 51C144.174 51 142.546 52.631 142.546 54.643C142.546 56.655 144.174 58.286 146.183 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M156.363 58.286C158.372 58.286 160 56.655 160 54.643C160 52.631 158.372 51 156.363 51C154.355 51 152.727 52.631 152.727 54.643C152.727 56.655 154.355 58.286 156.363 58.286Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M3.63639 48.0868C5.64472 48.0868 7.27279 46.4557 7.27279 44.4438C7.27279 42.4318 5.64472 40.8008 3.63639 40.8008C1.62807 40.8008 0 42.4318 0 44.4438C0 46.4557 1.62807 48.0868 3.63639 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M13.8171 48.0868C15.8254 48.0868 17.4535 46.4557 17.4535 44.4438C17.4535 42.4318 15.8254 40.8008 13.8171 40.8008C11.8087 40.8008 10.1807 42.4318 10.1807 44.4438C10.1807 46.4557 11.8087 48.0868 13.8171 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M23.9999 48.0868C26.0082 48.0868 27.6363 46.4557 27.6363 44.4438C27.6363 42.4318 26.0082 40.8008 23.9999 40.8008C21.9916 40.8008 20.3635 42.4318 20.3635 44.4438C20.3635 46.4557 21.9916 48.0868 23.9999 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M34.1825 48.0868C36.1909 48.0868 37.8189 46.4557 37.8189 44.4438C37.8189 42.4318 36.1909 40.8008 34.1825 40.8008C32.1742 40.8008 30.5461 42.4318 30.5461 44.4438C30.5461 46.4557 32.1742 48.0868 34.1825 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M44.3634 48.0868C46.3718 48.0868 47.9998 46.4557 47.9998 44.4438C47.9998 42.4318 46.3718 40.8008 44.3634 40.8008C42.3551 40.8008 40.7271 42.4318 40.7271 44.4438C40.7271 46.4557 42.3551 48.0868 44.3634 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M54.5461 48.0868C56.5544 48.0868 58.1825 46.4557 58.1825 44.4438C58.1825 42.4318 56.5544 40.8008 54.5461 40.8008C52.5377 40.8008 50.9097 42.4318 50.9097 44.4438C50.9097 46.4557 52.5377 48.0868 54.5461 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M64.7267 48.0868C66.7351 48.0868 68.3631 46.4557 68.3631 44.4438C68.3631 42.4318 66.7351 40.8008 64.7267 40.8008C62.7184 40.8008 61.0903 42.4318 61.0903 44.4438C61.0903 46.4557 62.7184 48.0868 64.7267 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M74.9096 48.0868C76.9179 48.0868 78.546 46.4557 78.546 44.4438C78.546 42.4318 76.9179 40.8008 74.9096 40.8008C72.9013 40.8008 71.2732 42.4318 71.2732 44.4438C71.2732 46.4557 72.9013 48.0868 74.9096 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M85.0922 48.0868C87.1005 48.0868 88.7286 46.4557 88.7286 44.4438C88.7286 42.4318 87.1005 40.8008 85.0922 40.8008C83.0839 40.8008 81.4558 42.4318 81.4558 44.4438C81.4558 46.4557 83.0839 48.0868 85.0922 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M95.2731 48.0868C97.2814 48.0868 98.9095 46.4557 98.9095 44.4438C98.9095 42.4318 97.2814 40.8008 95.2731 40.8008C93.2648 40.8008 91.6367 42.4318 91.6367 44.4438C91.6367 46.4557 93.2648 48.0868 95.2731 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M105.456 48.0868C107.464 48.0868 109.092 46.4557 109.092 44.4438C109.092 42.4318 107.464 40.8008 105.456 40.8008C103.447 40.8008 101.819 42.4318 101.819 44.4438C101.819 46.4557 103.447 48.0868 105.456 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M115.636 48.0868C117.645 48.0868 119.273 46.4557 119.273 44.4438C119.273 42.4318 117.645 40.8008 115.636 40.8008C113.628 40.8008 112 42.4318 112 44.4438C112 46.4557 113.628 48.0868 115.636 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M125.819 48.0868C127.828 48.0868 129.456 46.4557 129.456 44.4438C129.456 42.4318 127.828 40.8008 125.819 40.8008C123.811 40.8008 122.183 42.4318 122.183 44.4438C122.183 46.4557 123.811 48.0868 125.819 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M136.002 48.0868C138.01 48.0868 139.638 46.4557 139.638 44.4438C139.638 42.4318 138.01 40.8008 136.002 40.8008C133.994 40.8008 132.365 42.4318 132.365 44.4438C132.365 46.4557 133.994 48.0868 136.002 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M146.183 48.0868C148.191 48.0868 149.819 46.4557 149.819 44.4438C149.819 42.4318 148.191 40.8008 146.183 40.8008C144.174 40.8008 142.546 42.4318 142.546 44.4438C142.546 46.4557 144.174 48.0868 146.183 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M156.363 48.0868C158.372 48.0868 160 46.4557 160 44.4438C160 42.4318 158.372 40.8008 156.363 40.8008C154.355 40.8008 152.727 42.4318 152.727 44.4438C152.727 46.4557 154.355 48.0868 156.363 48.0868Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M3.63639 37.8875C5.64472 37.8875 7.27279 36.2565 7.27279 34.2445C7.27279 32.2326 5.64472 30.6016 3.63639 30.6016C1.62807 30.6016 0 32.2326 0 34.2445C0 36.2565 1.62807 37.8875 3.63639 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M13.8171 37.8875C15.8254 37.8875 17.4535 36.2565 17.4535 34.2445C17.4535 32.2326 15.8254 30.6016 13.8171 30.6016C11.8087 30.6016 10.1807 32.2326 10.1807 34.2445C10.1807 36.2565 11.8087 37.8875 13.8171 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M23.9999 37.8875C26.0082 37.8875 27.6363 36.2565 27.6363 34.2445C27.6363 32.2326 26.0082 30.6016 23.9999 30.6016C21.9916 30.6016 20.3635 32.2326 20.3635 34.2445C20.3635 36.2565 21.9916 37.8875 23.9999 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M34.1825 37.8875C36.1909 37.8875 37.8189 36.2565 37.8189 34.2445C37.8189 32.2326 36.1909 30.6016 34.1825 30.6016C32.1742 30.6016 30.5461 32.2326 30.5461 34.2445C30.5461 36.2565 32.1742 37.8875 34.1825 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M44.3634 37.8875C46.3718 37.8875 47.9998 36.2565 47.9998 34.2445C47.9998 32.2326 46.3718 30.6016 44.3634 30.6016C42.3551 30.6016 40.7271 32.2326 40.7271 34.2445C40.7271 36.2565 42.3551 37.8875 44.3634 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M54.5461 37.8875C56.5544 37.8875 58.1825 36.2565 58.1825 34.2445C58.1825 32.2326 56.5544 30.6016 54.5461 30.6016C52.5377 30.6016 50.9097 32.2326 50.9097 34.2445C50.9097 36.2565 52.5377 37.8875 54.5461 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M64.7267 37.8875C66.7351 37.8875 68.3631 36.2565 68.3631 34.2445C68.3631 32.2326 66.7351 30.6016 64.7267 30.6016C62.7184 30.6016 61.0903 32.2326 61.0903 34.2445C61.0903 36.2565 62.7184 37.8875 64.7267 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M74.9096 37.8875C76.9179 37.8875 78.546 36.2565 78.546 34.2445C78.546 32.2326 76.9179 30.6016 74.9096 30.6016C72.9013 30.6016 71.2732 32.2326 71.2732 34.2445C71.2732 36.2565 72.9013 37.8875 74.9096 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M85.0922 37.8875C87.1005 37.8875 88.7286 36.2565 88.7286 34.2445C88.7286 32.2326 87.1005 30.6016 85.0922 30.6016C83.0839 30.6016 81.4558 32.2326 81.4558 34.2445C81.4558 36.2565 83.0839 37.8875 85.0922 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M95.2731 37.8875C97.2814 37.8875 98.9095 36.2565 98.9095 34.2445C98.9095 32.2326 97.2814 30.6016 95.2731 30.6016C93.2648 30.6016 91.6367 32.2326 91.6367 34.2445C91.6367 36.2565 93.2648 37.8875 95.2731 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M105.456 37.8875C107.464 37.8875 109.092 36.2565 109.092 34.2445C109.092 32.2326 107.464 30.6016 105.456 30.6016C103.447 30.6016 101.819 32.2326 101.819 34.2445C101.819 36.2565 103.447 37.8875 105.456 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M115.636 37.8875C117.645 37.8875 119.273 36.2565 119.273 34.2445C119.273 32.2326 117.645 30.6016 115.636 30.6016C113.628 30.6016 112 32.2326 112 34.2445C112 36.2565 113.628 37.8875 115.636 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M125.819 37.8875C127.828 37.8875 129.456 36.2565 129.456 34.2445C129.456 32.2326 127.828 30.6016 125.819 30.6016C123.811 30.6016 122.183 32.2326 122.183 34.2445C122.183 36.2565 123.811 37.8875 125.819 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M136.002 37.8875C138.01 37.8875 139.638 36.2565 139.638 34.2445C139.638 32.2326 138.01 30.6016 136.002 30.6016C133.994 30.6016 132.365 32.2326 132.365 34.2445C132.365 36.2565 133.994 37.8875 136.002 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M146.183 37.8875C148.191 37.8875 149.819 36.2565 149.819 34.2445C149.819 32.2326 148.191 30.6016 146.183 30.6016C144.174 30.6016 142.546 32.2326 142.546 34.2445C142.546 36.2565 144.174 37.8875 146.183 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M156.363 37.8875C158.372 37.8875 160 36.2565 160 34.2445C160 32.2326 158.372 30.6016 156.363 30.6016C154.355 30.6016 152.727 32.2326 152.727 34.2445C152.727 36.2565 154.355 37.8875 156.363 37.8875Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M3.63639 27.6844C5.64472 27.6844 7.27279 26.0534 7.27279 24.0414C7.27279 22.0295 5.64472 20.3984 3.63639 20.3984C1.62807 20.3984 0 22.0295 0 24.0414C0 26.0534 1.62807 27.6844 3.63639 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M13.8171 27.6844C15.8254 27.6844 17.4535 26.0534 17.4535 24.0414C17.4535 22.0295 15.8254 20.3984 13.8171 20.3984C11.8087 20.3984 10.1807 22.0295 10.1807 24.0414C10.1807 26.0534 11.8087 27.6844 13.8171 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M23.9999 27.6844C26.0082 27.6844 27.6363 26.0534 27.6363 24.0414C27.6363 22.0295 26.0082 20.3984 23.9999 20.3984C21.9916 20.3984 20.3635 22.0295 20.3635 24.0414C20.3635 26.0534 21.9916 27.6844 23.9999 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M34.1825 27.6844C36.1909 27.6844 37.8189 26.0534 37.8189 24.0414C37.8189 22.0295 36.1909 20.3984 34.1825 20.3984C32.1742 20.3984 30.5461 22.0295 30.5461 24.0414C30.5461 26.0534 32.1742 27.6844 34.1825 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M44.3634 27.6844C46.3718 27.6844 47.9998 26.0534 47.9998 24.0414C47.9998 22.0295 46.3718 20.3984 44.3634 20.3984C42.3551 20.3984 40.7271 22.0295 40.7271 24.0414C40.7271 26.0534 42.3551 27.6844 44.3634 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M54.5461 27.6844C56.5544 27.6844 58.1825 26.0534 58.1825 24.0414C58.1825 22.0295 56.5544 20.3984 54.5461 20.3984C52.5377 20.3984 50.9097 22.0295 50.9097 24.0414C50.9097 26.0534 52.5377 27.6844 54.5461 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M64.7267 27.6844C66.7351 27.6844 68.3631 26.0534 68.3631 24.0414C68.3631 22.0295 66.7351 20.3984 64.7267 20.3984C62.7184 20.3984 61.0903 22.0295 61.0903 24.0414C61.0903 26.0534 62.7184 27.6844 64.7267 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M74.9096 27.6844C76.9179 27.6844 78.546 26.0534 78.546 24.0414C78.546 22.0295 76.9179 20.3984 74.9096 20.3984C72.9013 20.3984 71.2732 22.0295 71.2732 24.0414C71.2732 26.0534 72.9013 27.6844 74.9096 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M85.0922 27.6844C87.1005 27.6844 88.7286 26.0534 88.7286 24.0414C88.7286 22.0295 87.1005 20.3984 85.0922 20.3984C83.0839 20.3984 81.4558 22.0295 81.4558 24.0414C81.4558 26.0534 83.0839 27.6844 85.0922 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M95.2731 27.6844C97.2814 27.6844 98.9095 26.0534 98.9095 24.0414C98.9095 22.0295 97.2814 20.3984 95.2731 20.3984C93.2648 20.3984 91.6367 22.0295 91.6367 24.0414C91.6367 26.0534 93.2648 27.6844 95.2731 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M105.456 27.6844C107.464 27.6844 109.092 26.0534 109.092 24.0414C109.092 22.0295 107.464 20.3984 105.456 20.3984C103.447 20.3984 101.819 22.0295 101.819 24.0414C101.819 26.0534 103.447 27.6844 105.456 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M115.636 27.6844C117.645 27.6844 119.273 26.0534 119.273 24.0414C119.273 22.0295 117.645 20.3984 115.636 20.3984C113.628 20.3984 112 22.0295 112 24.0414C112 26.0534 113.628 27.6844 115.636 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M125.819 27.6844C127.828 27.6844 129.456 26.0534 129.456 24.0414C129.456 22.0295 127.828 20.3984 125.819 20.3984C123.811 20.3984 122.183 22.0295 122.183 24.0414C122.183 26.0534 123.811 27.6844 125.819 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M136.002 27.6844C138.01 27.6844 139.638 26.0534 139.638 24.0414C139.638 22.0295 138.01 20.3984 136.002 20.3984C133.994 20.3984 132.365 22.0295 132.365 24.0414C132.365 26.0534 133.994 27.6844 136.002 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M146.183 27.6844C148.191 27.6844 149.819 26.0534 149.819 24.0414C149.819 22.0295 148.191 20.3984 146.183 20.3984C144.174 20.3984 142.546 22.0295 142.546 24.0414C142.546 26.0534 144.174 27.6844 146.183 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M156.363 27.6844C158.372 27.6844 160 26.0534 160 24.0414C160 22.0295 158.372 20.3984 156.363 20.3984C154.355 20.3984 152.727 22.0295 152.727 24.0414C152.727 26.0534 154.355 27.6844 156.363 27.6844Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M3.63615 17.4852C5.64448 17.4852 7.27254 15.8542 7.27254 13.8422C7.27254 11.8302 5.64448 10.1992 3.63615 10.1992C1.62783 10.1992 -0.000244141 11.8302 -0.000244141 13.8422C-0.000244141 15.8542 1.62783 17.4852 3.63615 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M13.8171 17.4852C15.8254 17.4852 17.4535 15.8542 17.4535 13.8422C17.4535 11.8302 15.8254 10.1992 13.8171 10.1992C11.8087 10.1992 10.1807 11.8302 10.1807 13.8422C10.1807 15.8542 11.8087 17.4852 13.8171 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M23.9999 17.4852C26.0082 17.4852 27.6363 15.8542 27.6363 13.8422C27.6363 11.8302 26.0082 10.1992 23.9999 10.1992C21.9916 10.1992 20.3635 11.8302 20.3635 13.8422C20.3635 15.8542 21.9916 17.4852 23.9999 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M34.1825 17.4852C36.1909 17.4852 37.8189 15.8542 37.8189 13.8422C37.8189 11.8302 36.1909 10.1992 34.1825 10.1992C32.1742 10.1992 30.5461 11.8302 30.5461 13.8422C30.5461 15.8542 32.1742 17.4852 34.1825 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M44.3634 17.4852C46.3718 17.4852 47.9998 15.8542 47.9998 13.8422C47.9998 11.8302 46.3718 10.1992 44.3634 10.1992C42.3551 10.1992 40.7271 11.8302 40.7271 13.8422C40.7271 15.8542 42.3551 17.4852 44.3634 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M54.5461 17.4852C56.5544 17.4852 58.1825 15.8542 58.1825 13.8422C58.1825 11.8302 56.5544 10.1992 54.5461 10.1992C52.5377 10.1992 50.9097 11.8302 50.9097 13.8422C50.9097 15.8542 52.5377 17.4852 54.5461 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M64.7267 17.4852C66.7351 17.4852 68.3631 15.8542 68.3631 13.8422C68.3631 11.8302 66.7351 10.1992 64.7267 10.1992C62.7184 10.1992 61.0903 11.8302 61.0903 13.8422C61.0903 15.8542 62.7184 17.4852 64.7267 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M74.9096 17.4852C76.9179 17.4852 78.546 15.8542 78.546 13.8422C78.546 11.8302 76.9179 10.1992 74.9096 10.1992C72.9013 10.1992 71.2732 11.8302 71.2732 13.8422C71.2732 15.8542 72.9013 17.4852 74.9096 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M85.0922 17.4852C87.1005 17.4852 88.7286 15.8542 88.7286 13.8422C88.7286 11.8302 87.1005 10.1992 85.0922 10.1992C83.0839 10.1992 81.4558 11.8302 81.4558 13.8422C81.4558 15.8542 83.0839 17.4852 85.0922 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M95.2731 17.4852C97.2814 17.4852 98.9095 15.8542 98.9095 13.8422C98.9095 11.8302 97.2814 10.1992 95.2731 10.1992C93.2648 10.1992 91.6367 11.8302 91.6367 13.8422C91.6367 15.8542 93.2648 17.4852 95.2731 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M105.456 17.4852C107.464 17.4852 109.092 15.8542 109.092 13.8422C109.092 11.8302 107.464 10.1992 105.456 10.1992C103.447 10.1992 101.819 11.8302 101.819 13.8422C101.819 15.8542 103.447 17.4852 105.456 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M115.636 17.4852C117.645 17.4852 119.273 15.8542 119.273 13.8422C119.273 11.8302 117.645 10.1992 115.636 10.1992C113.628 10.1992 112 11.8302 112 13.8422C112 15.8542 113.628 17.4852 115.636 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M125.819 17.4852C127.828 17.4852 129.456 15.8542 129.456 13.8422C129.456 11.8302 127.828 10.1992 125.819 10.1992C123.811 10.1992 122.183 11.8302 122.183 13.8422C122.183 15.8542 123.811 17.4852 125.819 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M136.002 17.4852C138.01 17.4852 139.638 15.8542 139.638 13.8422C139.638 11.8302 138.01 10.1992 136.002 10.1992C133.994 10.1992 132.365 11.8302 132.365 13.8422C132.365 15.8542 133.994 17.4852 136.002 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M146.183 17.4852C148.191 17.4852 149.819 15.8542 149.819 13.8422C149.819 11.8302 148.191 10.1992 146.183 10.1992C144.174 10.1992 142.546 11.8302 142.546 13.8422C142.546 15.8542 144.174 17.4852 146.183 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M156.363 17.4852C158.372 17.4852 160 15.8542 160 13.8422C160 11.8302 158.372 10.1992 156.363 10.1992C154.355 10.1992 152.727 11.8302 152.727 13.8422C152.727 15.8542 154.355 17.4852 156.363 17.4852Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M3.63639 7.28597C5.64472 7.28597 7.27279 5.65495 7.27279 3.64299C7.27279 1.63102 5.64472 0 3.63639 0C1.62807 0 0 1.63102 0 3.64299C0 5.65495 1.62807 7.28597 3.63639 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M13.8171 7.28597C15.8254 7.28597 17.4535 5.65495 17.4535 3.64299C17.4535 1.63102 15.8254 0 13.8171 0C11.8087 0 10.1807 1.63102 10.1807 3.64299C10.1807 5.65495 11.8087 7.28597 13.8171 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M23.9999 7.28597C26.0082 7.28597 27.6363 5.65495 27.6363 3.64299C27.6363 1.63102 26.0082 0 23.9999 0C21.9916 0 20.3635 1.63102 20.3635 3.64299C20.3635 5.65495 21.9916 7.28597 23.9999 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M34.1825 7.28597C36.1909 7.28597 37.8189 5.65495 37.8189 3.64299C37.8189 1.63102 36.1909 0 34.1825 0C32.1742 0 30.5461 1.63102 30.5461 3.64299C30.5461 5.65495 32.1742 7.28597 34.1825 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M44.3634 7.28597C46.3718 7.28597 47.9998 5.65495 47.9998 3.64299C47.9998 1.63102 46.3718 0 44.3634 0C42.3551 0 40.7271 1.63102 40.7271 3.64299C40.7271 5.65495 42.3551 7.28597 44.3634 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M54.5461 7.28597C56.5544 7.28597 58.1825 5.65495 58.1825 3.64299C58.1825 1.63102 56.5544 0 54.5461 0C52.5377 0 50.9097 1.63102 50.9097 3.64299C50.9097 5.65495 52.5377 7.28597 54.5461 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M64.7267 7.28597C66.7351 7.28597 68.3631 5.65495 68.3631 3.64299C68.3631 1.63102 66.7351 0 64.7267 0C62.7184 0 61.0903 1.63102 61.0903 3.64299C61.0903 5.65495 62.7184 7.28597 64.7267 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M74.9096 7.28597C76.9179 7.28597 78.546 5.65495 78.546 3.64299C78.546 1.63102 76.9179 0 74.9096 0C72.9013 0 71.2732 1.63102 71.2732 3.64299C71.2732 5.65495 72.9013 7.28597 74.9096 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M85.0922 7.28597C87.1005 7.28597 88.7286 5.65495 88.7286 3.64299C88.7286 1.63102 87.1005 0 85.0922 0C83.0839 0 81.4558 1.63102 81.4558 3.64299C81.4558 5.65495 83.0839 7.28597 85.0922 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M95.2731 7.28597C97.2814 7.28597 98.9095 5.65495 98.9095 3.64299C98.9095 1.63102 97.2814 0 95.2731 0C93.2648 0 91.6367 1.63102 91.6367 3.64299C91.6367 5.65495 93.2648 7.28597 95.2731 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M105.456 7.28597C107.464 7.28597 109.092 5.65495 109.092 3.64299C109.092 1.63102 107.464 0 105.456 0C103.447 0 101.819 1.63102 101.819 3.64299C101.819 5.65495 103.447 7.28597 105.456 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M115.636 7.28597C117.645 7.28597 119.273 5.65495 119.273 3.64299C119.273 1.63102 117.645 0 115.636 0C113.628 0 112 1.63102 112 3.64299C112 5.65495 113.628 7.28597 115.636 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M125.819 7.28597C127.828 7.28597 129.456 5.65495 129.456 3.64299C129.456 1.63102 127.828 0 125.819 0C123.811 0 122.183 1.63102 122.183 3.64299C122.183 5.65495 123.811 7.28597 125.819 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M136.002 7.28597C138.01 7.28597 139.638 5.65495 139.638 3.64299C139.638 1.63102 138.01 0 136.002 0C133.994 0 132.365 1.63102 132.365 3.64299C132.365 5.65495 133.994 7.28597 136.002 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M146.183 7.28597C148.191 7.28597 149.819 5.65495 149.819 3.64299C149.819 1.63102 148.191 0 146.183 0C144.174 0 142.546 1.63102 142.546 3.64299C142.546 5.65495 144.174 7.28597 146.183 7.28597Z",
    fill: "#211242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M156.363 7.28597C158.372 7.28597 160 5.65495 160 3.64299C160 1.63102 158.372 0 156.363 0C154.355 0 152.727 1.63102 152.727 3.64299C152.727 5.65495 154.355 7.28597 156.363 7.28597Z",
    fill: "#211242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M23.602 150.091C25.6103 150.091 27.2384 148.46 27.2384 146.448C27.2384 144.436 25.6103 142.805 23.602 142.805C21.5936 142.805 19.9656 144.436 19.9656 146.448C19.9656 148.46 21.5936 150.091 23.602 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M135.602 150.091C137.61 150.091 139.238 148.46 139.238 146.448C139.238 144.436 137.61 142.805 135.602 142.805C133.594 142.805 131.966 144.436 131.966 146.448C131.966 148.46 133.594 150.091 135.602 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M23.602 139.891C25.6103 139.891 27.2384 138.26 27.2384 136.248C27.2384 134.236 25.6103 132.605 23.602 132.605C21.5936 132.605 19.9656 134.236 19.9656 136.248C19.9656 138.26 21.5936 139.891 23.602 139.891Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M135.602 139.891C137.61 139.891 139.238 138.26 139.238 136.248C139.238 134.236 137.61 132.605 135.602 132.605C133.594 132.605 131.966 134.236 131.966 136.248C131.966 138.26 133.594 139.891 135.602 139.891Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M23.602 160.001C25.6103 160.001 27.2384 158.37 27.2384 156.358C27.2384 154.346 25.6103 152.715 23.602 152.715C21.5936 152.715 19.9656 154.346 19.9656 156.358C19.9656 158.37 21.5936 160.001 23.602 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M33.7826 160.001C35.791 160.001 37.419 158.37 37.419 156.358C37.419 154.346 35.791 152.715 33.7826 152.715C31.7743 152.715 30.1462 154.346 30.1462 156.358C30.1462 158.37 31.7743 160.001 33.7826 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M43.9655 160.001C45.9738 160.001 47.6019 158.37 47.6019 156.358C47.6019 154.346 45.9738 152.715 43.9655 152.715C41.9572 152.715 40.3291 154.346 40.3291 156.358C40.3291 158.37 41.9572 160.001 43.9655 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M54.1481 160.001C56.1564 160.001 57.7845 158.37 57.7845 156.358C57.7845 154.346 56.1564 152.715 54.1481 152.715C52.1398 152.715 50.5117 154.346 50.5117 156.358C50.5117 158.37 52.1398 160.001 54.1481 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M64.329 160.001C66.3373 160.001 67.9654 158.37 67.9654 156.358C67.9654 154.346 66.3373 152.715 64.329 152.715C62.3207 152.715 60.6926 154.346 60.6926 156.358C60.6926 158.37 62.3207 160.001 64.329 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M74.5116 160.001C76.52 160.001 78.148 158.37 78.148 156.358C78.148 154.346 76.52 152.715 74.5116 152.715C72.5033 152.715 70.8752 154.346 70.8752 156.358C70.8752 158.37 72.5033 160.001 74.5116 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M84.6923 160.001C86.7006 160.001 88.3287 158.37 88.3287 156.358C88.3287 154.346 86.7006 152.715 84.6923 152.715C82.684 152.715 81.0559 154.346 81.0559 156.358C81.0559 158.37 82.684 160.001 84.6923 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M94.8752 160.001C96.8835 160.001 98.5116 158.37 98.5116 156.358C98.5116 154.346 96.8835 152.715 94.8752 152.715C92.8668 152.715 91.2388 154.346 91.2388 156.358C91.2388 158.37 92.8668 160.001 94.8752 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M105.058 160.001C107.066 160.001 108.694 158.37 108.694 156.358C108.694 154.346 107.066 152.715 105.058 152.715C103.049 152.715 101.421 154.346 101.421 156.358C101.421 158.37 103.049 160.001 105.058 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M115.238 160.001C117.247 160.001 118.875 158.37 118.875 156.358C118.875 154.346 117.247 152.715 115.238 152.715C113.23 152.715 111.602 154.346 111.602 156.358C111.602 158.37 113.23 160.001 115.238 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M125.421 160.001C127.43 160.001 129.058 158.37 129.058 156.358C129.058 154.346 127.43 152.715 125.421 152.715C123.413 152.715 121.785 154.346 121.785 156.358C121.785 158.37 123.413 160.001 125.421 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M33.7826 150.091C35.791 150.091 37.419 148.46 37.419 146.448C37.419 144.436 35.791 142.805 33.7826 142.805C31.7743 142.805 30.1462 144.436 30.1462 146.448C30.1462 148.46 31.7743 150.091 33.7826 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M43.9655 150.091C45.9738 150.091 47.6019 148.46 47.6019 146.448C47.6019 144.436 45.9738 142.805 43.9655 142.805C41.9572 142.805 40.3291 144.436 40.3291 146.448C40.3291 148.46 41.9572 150.091 43.9655 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M54.1481 150.091C56.1564 150.091 57.7845 148.46 57.7845 146.448C57.7845 144.436 56.1564 142.805 54.1481 142.805C52.1398 142.805 50.5117 144.436 50.5117 146.448C50.5117 148.46 52.1398 150.091 54.1481 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M64.329 150.091C66.3373 150.091 67.9654 148.46 67.9654 146.448C67.9654 144.436 66.3373 142.805 64.329 142.805C62.3207 142.805 60.6926 144.436 60.6926 146.448C60.6926 148.46 62.3207 150.091 64.329 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M74.5116 150.091C76.52 150.091 78.148 148.46 78.148 146.448C78.148 144.436 76.52 142.805 74.5116 142.805C72.5033 142.805 70.8752 144.436 70.8752 146.448C70.8752 148.46 72.5033 150.091 74.5116 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M84.6923 150.091C86.7006 150.091 88.3287 148.46 88.3287 146.448C88.3287 144.436 86.7006 142.805 84.6923 142.805C82.684 142.805 81.0559 144.436 81.0559 146.448C81.0559 148.46 82.684 150.091 84.6923 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M94.8752 150.091C96.8835 150.091 98.5116 148.46 98.5116 146.448C98.5116 144.436 96.8835 142.805 94.8752 142.805C92.8668 142.805 91.2388 144.436 91.2388 146.448C91.2388 148.46 92.8668 150.091 94.8752 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M105.058 150.091C107.066 150.091 108.694 148.46 108.694 146.448C108.694 144.436 107.066 142.805 105.058 142.805C103.049 142.805 101.421 144.436 101.421 146.448C101.421 148.46 103.049 150.091 105.058 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M115.238 150.091C117.247 150.091 118.875 148.46 118.875 146.448C118.875 144.436 117.247 142.805 115.238 142.805C113.23 142.805 111.602 144.436 111.602 146.448C111.602 148.46 113.23 150.091 115.238 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M125.421 150.091C127.43 150.091 129.058 148.46 129.058 146.448C129.058 144.436 127.43 142.805 125.421 142.805C123.413 142.805 121.785 144.436 121.785 146.448C121.785 148.46 123.413 150.091 125.421 150.091Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M135.602 160.001C137.61 160.001 139.238 158.37 139.238 156.358C139.238 154.346 137.61 152.715 135.602 152.715C133.594 152.715 131.966 154.346 131.966 156.358C131.966 158.37 133.594 160.001 135.602 160.001Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M23.602 129.692C25.6103 129.692 27.2384 128.061 27.2384 126.049C27.2384 124.037 25.6103 122.406 23.602 122.406C21.5936 122.406 19.9656 124.037 19.9656 126.049C19.9656 128.061 21.5936 129.692 23.602 129.692Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M135.602 129.692C137.61 129.692 139.238 128.061 139.238 126.049C139.238 124.037 137.61 122.406 135.602 122.406C133.594 122.406 131.966 124.037 131.966 126.049C131.966 128.061 133.594 129.692 135.602 129.692Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M23.602 119.489C25.6103 119.489 27.2384 117.858 27.2384 115.846C27.2384 113.834 25.6103 112.203 23.602 112.203C21.5936 112.203 19.9656 113.834 19.9656 115.846C19.9656 117.858 21.5936 119.489 23.602 119.489Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M135.602 119.489C137.61 119.489 139.238 117.858 139.238 115.846C139.238 113.834 137.61 112.203 135.602 112.203C133.594 112.203 131.966 113.834 131.966 115.846C131.966 117.858 133.594 119.489 135.602 119.489Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M23.602 109.29C25.6103 109.29 27.2384 107.659 27.2384 105.647C27.2384 103.635 25.6103 102.004 23.602 102.004C21.5936 102.004 19.9656 103.635 19.9656 105.647C19.9656 107.659 21.5936 109.29 23.602 109.29Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M135.602 109.29C137.61 109.29 139.238 107.659 139.238 105.647C139.238 103.635 137.61 102.004 135.602 102.004C133.594 102.004 131.966 103.635 131.966 105.647C131.966 107.659 133.594 109.29 135.602 109.29Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M23.602 99.0907C25.6103 99.0907 27.2384 97.4596 27.2384 95.4477C27.2384 93.4357 25.6103 91.8047 23.602 91.8047C21.5936 91.8047 19.9656 93.4357 19.9656 95.4477C19.9656 97.4596 21.5936 99.0907 23.602 99.0907Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M135.602 99.0907C137.61 99.0907 139.238 97.4596 139.238 95.4477C139.238 93.4357 137.61 91.8047 135.602 91.8047C133.594 91.8047 131.966 93.4357 131.966 95.4477C131.966 97.4596 133.594 99.0907 135.602 99.0907Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M23.602 88.8875C25.6103 88.8875 27.2384 87.2565 27.2384 85.2445C27.2384 83.2326 25.6103 81.6016 23.602 81.6016C21.5936 81.6016 19.9656 83.2326 19.9656 85.2445C19.9656 87.2565 21.5936 88.8875 23.602 88.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M135.602 88.8875C137.61 88.8875 139.238 87.2565 139.238 85.2445C139.238 83.2326 137.61 81.6016 135.602 81.6016C133.594 81.6016 131.966 83.2326 131.966 85.2445C131.966 87.2565 133.594 88.8875 135.602 88.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M23.602 78.6883C25.6103 78.6883 27.2384 77.0573 27.2384 75.0453C27.2384 73.0334 25.6103 71.4023 23.602 71.4023C21.5936 71.4023 19.9656 73.0334 19.9656 75.0453C19.9656 77.0573 21.5936 78.6883 23.602 78.6883Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M135.602 78.6883C137.61 78.6883 139.238 77.0573 139.238 75.0453C139.238 73.0334 137.61 71.4023 135.602 71.4023C133.594 71.4023 131.966 73.0334 131.966 75.0453C131.966 77.0573 133.594 78.6883 135.602 78.6883Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M23.602 68.4891C25.6103 68.4891 27.2384 66.8581 27.2384 64.8461C27.2384 62.8341 25.6103 61.2031 23.602 61.2031C21.5936 61.2031 19.9656 62.8341 19.9656 64.8461C19.9656 66.8581 21.5936 68.4891 23.602 68.4891Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M135.602 68.4891C137.61 68.4891 139.238 66.8581 139.238 64.8461C139.238 62.8341 137.61 61.2031 135.602 61.2031C133.594 61.2031 131.966 62.8341 131.966 64.8461C131.966 66.8581 133.594 68.4891 135.602 68.4891Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M23.602 58.286C25.6103 58.286 27.2384 56.655 27.2384 54.643C27.2384 52.631 25.6103 51 23.602 51C21.5936 51 19.9656 52.631 19.9656 54.643C19.9656 56.655 21.5936 58.286 23.602 58.286Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M135.602 58.286C137.61 58.286 139.238 56.655 139.238 54.643C139.238 52.631 137.61 51 135.602 51C133.594 51 131.966 52.631 131.966 54.643C131.966 56.655 133.594 58.286 135.602 58.286Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M23.602 48.0868C25.6103 48.0868 27.2384 46.4557 27.2384 44.4438C27.2384 42.4318 25.6103 40.8008 23.602 40.8008C21.5936 40.8008 19.9656 42.4318 19.9656 44.4438C19.9656 46.4557 21.5936 48.0868 23.602 48.0868Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M135.602 48.0868C137.61 48.0868 139.238 46.4557 139.238 44.4438C139.238 42.4318 137.61 40.8008 135.602 40.8008C133.594 40.8008 131.966 42.4318 131.966 44.4438C131.966 46.4557 133.594 48.0868 135.602 48.0868Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M23.602 37.8875C25.6103 37.8875 27.2384 36.2565 27.2384 34.2445C27.2384 32.2326 25.6103 30.6016 23.602 30.6016C21.5936 30.6016 19.9656 32.2326 19.9656 34.2445C19.9656 36.2565 21.5936 37.8875 23.602 37.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M64.329 37.8875C66.3373 37.8875 67.9654 36.2565 67.9654 34.2445C67.9654 32.2326 66.3373 30.6016 64.329 30.6016C62.3207 30.6016 60.6926 32.2326 60.6926 34.2445C60.6926 36.2565 62.3207 37.8875 64.329 37.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M74.5116 37.8875C76.52 37.8875 78.148 36.2565 78.148 34.2445C78.148 32.2326 76.52 30.6016 74.5116 30.6016C72.5033 30.6016 70.8752 32.2326 70.8752 34.2445C70.8752 36.2565 72.5033 37.8875 74.5116 37.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M84.6923 37.8875C86.7006 37.8875 88.3287 36.2565 88.3287 34.2445C88.3287 32.2326 86.7006 30.6016 84.6923 30.6016C82.684 30.6016 81.0559 32.2326 81.0559 34.2445C81.0559 36.2565 82.684 37.8875 84.6923 37.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M94.8752 37.8875C96.8835 37.8875 98.5116 36.2565 98.5116 34.2445C98.5116 32.2326 96.8835 30.6016 94.8752 30.6016C92.8668 30.6016 91.2388 32.2326 91.2388 34.2445C91.2388 36.2565 92.8668 37.8875 94.8752 37.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M54.1481 58.286C56.1564 58.286 57.7845 56.655 57.7845 54.643C57.7845 52.631 56.1564 51 54.1481 51C52.1398 51 50.5117 52.631 50.5117 54.643C50.5117 56.655 52.1398 58.286 54.1481 58.286Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M64.329 58.286C66.3373 58.286 67.9654 56.655 67.9654 54.643C67.9654 52.631 66.3373 51 64.329 51C62.3207 51 60.6926 52.631 60.6926 54.643C60.6926 56.655 62.3207 58.286 64.329 58.286Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M74.5116 58.286C76.52 58.286 78.148 56.655 78.148 54.643C78.148 52.631 76.52 51 74.5116 51C72.5033 51 70.8752 52.631 70.8752 54.643C70.8752 56.655 72.5033 58.286 74.5116 58.286Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M84.6923 58.286C86.7006 58.286 88.3287 56.655 88.3287 54.643C88.3287 52.631 86.7006 51 84.6923 51C82.684 51 81.0559 52.631 81.0559 54.643C81.0559 56.655 82.684 58.286 84.6923 58.286Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M94.8752 58.286C96.8835 58.286 98.5116 56.655 98.5116 54.643C98.5116 52.631 96.8835 51 94.8752 51C92.8668 51 91.2388 52.631 91.2388 54.643C91.2388 56.655 92.8668 58.286 94.8752 58.286Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M105.058 58.286C107.066 58.286 108.694 56.655 108.694 54.643C108.694 52.631 107.066 51 105.058 51C103.049 51 101.421 52.631 101.421 54.643C101.421 56.655 103.049 58.286 105.058 58.286Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M135.602 37.8875C137.61 37.8875 139.238 36.2565 139.238 34.2445C139.238 32.2326 137.61 30.6016 135.602 30.6016C133.594 30.6016 131.966 32.2326 131.966 34.2445C131.966 36.2565 133.594 37.8875 135.602 37.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M23.602 27.6844C25.6103 27.6844 27.2384 26.0534 27.2384 24.0414C27.2384 22.0295 25.6103 20.3984 23.602 20.3984C21.5936 20.3984 19.9656 22.0295 19.9656 24.0414C19.9656 26.0534 21.5936 27.6844 23.602 27.6844Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M33.7826 139.891C35.791 139.891 37.419 138.26 37.419 136.248C37.419 134.236 35.791 132.605 33.7826 132.605C31.7743 132.605 30.1462 134.236 30.1462 136.248C30.1462 138.26 31.7743 139.891 33.7826 139.891Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M33.7826 129.692C35.791 129.692 37.419 128.061 37.419 126.049C37.419 124.037 35.791 122.406 33.7826 122.406C31.7743 122.406 30.1462 124.037 30.1462 126.049C30.1462 128.061 31.7743 129.692 33.7826 129.692Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M33.7826 119.489C35.791 119.489 37.419 117.858 37.419 115.846C37.419 113.834 35.791 112.203 33.7826 112.203C31.7743 112.203 30.1462 113.834 30.1462 115.846C30.1462 117.858 31.7743 119.489 33.7826 119.489Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M33.7826 109.29C35.791 109.29 37.419 107.659 37.419 105.647C37.419 103.635 35.791 102.004 33.7826 102.004C31.7743 102.004 30.1462 103.635 30.1462 105.647C30.1462 107.659 31.7743 109.29 33.7826 109.29Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M33.7826 99.0907C35.791 99.0907 37.419 97.4596 37.419 95.4477C37.419 93.4357 35.791 91.8047 33.7826 91.8047C31.7743 91.8047 30.1462 93.4357 30.1462 95.4477C30.1462 97.4596 31.7743 99.0907 33.7826 99.0907Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M33.7826 88.8875C35.791 88.8875 37.419 87.2565 37.419 85.2445C37.419 83.2326 35.791 81.6016 33.7826 81.6016C31.7743 81.6016 30.1462 83.2326 30.1462 85.2445C30.1462 87.2565 31.7743 88.8875 33.7826 88.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M33.7826 78.6883C35.791 78.6883 37.419 77.0573 37.419 75.0453C37.419 73.0334 35.791 71.4023 33.7826 71.4023C31.7743 71.4023 30.1462 73.0334 30.1462 75.0453C30.1462 77.0573 31.7743 78.6883 33.7826 78.6883Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M33.7826 68.4891C35.791 68.4891 37.419 66.8581 37.419 64.8461C37.419 62.8341 35.791 61.2031 33.7826 61.2031C31.7743 61.2031 30.1462 62.8341 30.1462 64.8461C30.1462 66.8581 31.7743 68.4891 33.7826 68.4891Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M33.7826 58.286C35.791 58.286 37.419 56.655 37.419 54.643C37.419 52.631 35.791 51 33.7826 51C31.7743 51 30.1462 52.631 30.1462 54.643C30.1462 56.655 31.7743 58.286 33.7826 58.286Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M33.7826 48.0868C35.791 48.0868 37.419 46.4557 37.419 44.4438C37.419 42.4318 35.791 40.8008 33.7826 40.8008C31.7743 40.8008 30.1462 42.4318 30.1462 44.4438C30.1462 46.4557 31.7743 48.0868 33.7826 48.0868Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M33.7826 37.8875C35.791 37.8875 37.419 36.2565 37.419 34.2445C37.419 32.2326 35.791 30.6016 33.7826 30.6016C31.7743 30.6016 30.1462 32.2326 30.1462 34.2445C30.1462 36.2565 31.7743 37.8875 33.7826 37.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M33.7826 27.6844C35.791 27.6844 37.419 26.0534 37.419 24.0414C37.419 22.0295 35.791 20.3984 33.7826 20.3984C31.7743 20.3984 30.1462 22.0295 30.1462 24.0414C30.1462 26.0534 31.7743 27.6844 33.7826 27.6844Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M135.602 27.6844C137.61 27.6844 139.238 26.0534 139.238 24.0414C139.238 22.0295 137.61 20.3984 135.602 20.3984C133.594 20.3984 131.966 22.0295 131.966 24.0414C131.966 26.0534 133.594 27.6844 135.602 27.6844Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M125.421 139.891C127.43 139.891 129.058 138.26 129.058 136.248C129.058 134.236 127.43 132.605 125.421 132.605C123.413 132.605 121.785 134.236 121.785 136.248C121.785 138.26 123.413 139.891 125.421 139.891Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M125.421 129.692C127.43 129.692 129.058 128.061 129.058 126.049C129.058 124.037 127.43 122.406 125.421 122.406C123.413 122.406 121.785 124.037 121.785 126.049C121.785 128.061 123.413 129.692 125.421 129.692Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M125.421 119.489C127.43 119.489 129.058 117.858 129.058 115.846C129.058 113.834 127.43 112.203 125.421 112.203C123.413 112.203 121.785 113.834 121.785 115.846C121.785 117.858 123.413 119.489 125.421 119.489Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M125.421 109.29C127.43 109.29 129.058 107.659 129.058 105.647C129.058 103.635 127.43 102.004 125.421 102.004C123.413 102.004 121.785 103.635 121.785 105.647C121.785 107.659 123.413 109.29 125.421 109.29Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M125.421 99.0907C127.43 99.0907 129.058 97.4596 129.058 95.4477C129.058 93.4357 127.43 91.8047 125.421 91.8047C123.413 91.8047 121.785 93.4357 121.785 95.4477C121.785 97.4596 123.413 99.0907 125.421 99.0907Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M125.421 88.8875C127.43 88.8875 129.058 87.2565 129.058 85.2445C129.058 83.2326 127.43 81.6016 125.421 81.6016C123.413 81.6016 121.785 83.2326 121.785 85.2445C121.785 87.2565 123.413 88.8875 125.421 88.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M125.421 78.6883C127.43 78.6883 129.058 77.0573 129.058 75.0453C129.058 73.0334 127.43 71.4023 125.421 71.4023C123.413 71.4023 121.785 73.0334 121.785 75.0453C121.785 77.0573 123.413 78.6883 125.421 78.6883Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M125.421 68.4891C127.43 68.4891 129.058 66.8581 129.058 64.8461C129.058 62.8341 127.43 61.2031 125.421 61.2031C123.413 61.2031 121.785 62.8341 121.785 64.8461C121.785 66.8581 123.413 68.4891 125.421 68.4891Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M125.421 58.286C127.43 58.286 129.058 56.655 129.058 54.643C129.058 52.631 127.43 51 125.421 51C123.413 51 121.785 52.631 121.785 54.643C121.785 56.655 123.413 58.286 125.421 58.286Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M125.421 48.0868C127.43 48.0868 129.058 46.4557 129.058 44.4438C129.058 42.4318 127.43 40.8008 125.421 40.8008C123.413 40.8008 121.785 42.4318 121.785 44.4438C121.785 46.4557 123.413 48.0868 125.421 48.0868Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M125.421 37.8875C127.43 37.8875 129.058 36.2565 129.058 34.2445C129.058 32.2326 127.43 30.6016 125.421 30.6016C123.413 30.6016 121.785 32.2326 121.785 34.2445C121.785 36.2565 123.413 37.8875 125.421 37.8875Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M125.421 27.6844C127.43 27.6844 129.058 26.0534 129.058 24.0414C129.058 22.0295 127.43 20.3984 125.421 20.3984C123.413 20.3984 121.785 22.0295 121.785 24.0414C121.785 26.0534 123.413 27.6844 125.421 27.6844Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M23.602 17.4852C25.6103 17.4852 27.2384 15.8542 27.2384 13.8422C27.2384 11.8302 25.6103 10.1992 23.602 10.1992C21.5936 10.1992 19.9656 11.8302 19.9656 13.8422C19.9656 15.8542 21.5936 17.4852 23.602 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M135.602 17.4852C137.61 17.4852 139.238 15.8542 139.238 13.8422C139.238 11.8302 137.61 10.1992 135.602 10.1992C133.594 10.1992 131.966 11.8302 131.966 13.8422C131.966 15.8542 133.594 17.4852 135.602 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M23.602 7.28597C25.6103 7.28597 27.2384 5.65495 27.2384 3.64299C27.2384 1.63102 25.6103 0 23.602 0C21.5936 0 19.9656 1.63102 19.9656 3.64299C19.9656 5.65495 21.5936 7.28597 23.602 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M33.7826 7.28597C35.791 7.28597 37.419 5.65495 37.419 3.64299C37.419 1.63102 35.791 0 33.7826 0C31.7743 0 30.1462 1.63102 30.1462 3.64299C30.1462 5.65495 31.7743 7.28597 33.7826 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M43.9655 7.28597C45.9738 7.28597 47.6019 5.65495 47.6019 3.64299C47.6019 1.63102 45.9738 0 43.9655 0C41.9572 0 40.3291 1.63102 40.3291 3.64299C40.3291 5.65495 41.9572 7.28597 43.9655 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M54.1481 7.28597C56.1564 7.28597 57.7845 5.65495 57.7845 3.64299C57.7845 1.63102 56.1564 0 54.1481 0C52.1398 0 50.5117 1.63102 50.5117 3.64299C50.5117 5.65495 52.1398 7.28597 54.1481 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M64.329 7.28597C66.3373 7.28597 67.9654 5.65495 67.9654 3.64299C67.9654 1.63102 66.3373 0 64.329 0C62.3207 0 60.6926 1.63102 60.6926 3.64299C60.6926 5.65495 62.3207 7.28597 64.329 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M74.5116 7.28597C76.52 7.28597 78.148 5.65495 78.148 3.64299C78.148 1.63102 76.52 0 74.5116 0C72.5033 0 70.8752 1.63102 70.8752 3.64299C70.8752 5.65495 72.5033 7.28597 74.5116 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M84.6923 7.28597C86.7006 7.28597 88.3287 5.65495 88.3287 3.64299C88.3287 1.63102 86.7006 0 84.6923 0C82.684 0 81.0559 1.63102 81.0559 3.64299C81.0559 5.65495 82.684 7.28597 84.6923 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M94.8752 7.28597C96.8835 7.28597 98.5116 5.65495 98.5116 3.64299C98.5116 1.63102 96.8835 0 94.8752 0C92.8668 0 91.2388 1.63102 91.2388 3.64299C91.2388 5.65495 92.8668 7.28597 94.8752 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M105.058 7.28597C107.066 7.28597 108.694 5.65495 108.694 3.64299C108.694 1.63102 107.066 0 105.058 0C103.049 0 101.421 1.63102 101.421 3.64299C101.421 5.65495 103.049 7.28597 105.058 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M115.238 7.28597C117.247 7.28597 118.875 5.65495 118.875 3.64299C118.875 1.63102 117.247 0 115.238 0C113.23 0 111.602 1.63102 111.602 3.64299C111.602 5.65495 113.23 7.28597 115.238 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M125.421 7.28597C127.43 7.28597 129.058 5.65495 129.058 3.64299C129.058 1.63102 127.43 0 125.421 0C123.413 0 121.785 1.63102 121.785 3.64299C121.785 5.65495 123.413 7.28597 125.421 7.28597Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M33.7826 17.4852C35.791 17.4852 37.419 15.8542 37.419 13.8422C37.419 11.8302 35.791 10.1992 33.7826 10.1992C31.7743 10.1992 30.1462 11.8302 30.1462 13.8422C30.1462 15.8542 31.7743 17.4852 33.7826 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M43.9655 17.4852C45.9738 17.4852 47.6019 15.8542 47.6019 13.8422C47.6019 11.8302 45.9738 10.1992 43.9655 10.1992C41.9572 10.1992 40.3291 11.8302 40.3291 13.8422C40.3291 15.8542 41.9572 17.4852 43.9655 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M54.1481 17.4852C56.1564 17.4852 57.7845 15.8542 57.7845 13.8422C57.7845 11.8302 56.1564 10.1992 54.1481 10.1992C52.1398 10.1992 50.5117 11.8302 50.5117 13.8422C50.5117 15.8542 52.1398 17.4852 54.1481 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M64.329 17.4852C66.3373 17.4852 67.9654 15.8542 67.9654 13.8422C67.9654 11.8302 66.3373 10.1992 64.329 10.1992C62.3207 10.1992 60.6926 11.8302 60.6926 13.8422C60.6926 15.8542 62.3207 17.4852 64.329 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M74.5116 17.4852C76.52 17.4852 78.148 15.8542 78.148 13.8422C78.148 11.8302 76.52 10.1992 74.5116 10.1992C72.5033 10.1992 70.8752 11.8302 70.8752 13.8422C70.8752 15.8542 72.5033 17.4852 74.5116 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M84.6923 17.4852C86.7006 17.4852 88.3287 15.8542 88.3287 13.8422C88.3287 11.8302 86.7006 10.1992 84.6923 10.1992C82.684 10.1992 81.0559 11.8302 81.0559 13.8422C81.0559 15.8542 82.684 17.4852 84.6923 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M94.8752 17.4852C96.8835 17.4852 98.5116 15.8542 98.5116 13.8422C98.5116 11.8302 96.8835 10.1992 94.8752 10.1992C92.8668 10.1992 91.2388 11.8302 91.2388 13.8422C91.2388 15.8542 92.8668 17.4852 94.8752 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M105.058 17.4852C107.066 17.4852 108.694 15.8542 108.694 13.8422C108.694 11.8302 107.066 10.1992 105.058 10.1992C103.049 10.1992 101.421 11.8302 101.421 13.8422C101.421 15.8542 103.049 17.4852 105.058 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M115.238 17.4852C117.247 17.4852 118.875 15.8542 118.875 13.8422C118.875 11.8302 117.247 10.1992 115.238 10.1992C113.23 10.1992 111.602 11.8302 111.602 13.8422C111.602 15.8542 113.23 17.4852 115.238 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M125.421 17.4852C127.43 17.4852 129.058 15.8542 129.058 13.8422C129.058 11.8302 127.43 10.1992 125.421 10.1992C123.413 10.1992 121.785 11.8302 121.785 13.8422C121.785 15.8542 123.413 17.4852 125.421 17.4852Z",
    fill: "#A3DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M135.602 7.28597C137.61 7.28597 139.238 5.65495 139.238 3.64299C139.238 1.63102 137.61 0 135.602 0C133.594 0 131.966 1.63102 131.966 3.64299C131.966 5.65495 133.594 7.28597 135.602 7.28597Z",
    fill: "#A3DEFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M74.5099 119.489C76.5183 119.489 78.1463 117.858 78.1463 115.846C78.1463 113.834 76.5183 112.203 74.5099 112.203C72.5016 112.203 70.8735 113.834 70.8735 115.846C70.8735 117.858 72.5016 119.489 74.5099 119.489Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M84.6908 119.489C86.6992 119.489 88.3272 117.858 88.3272 115.846C88.3272 113.834 86.6992 112.203 84.6908 112.203C82.6825 112.203 81.0544 113.834 81.0544 115.846C81.0544 117.858 82.6825 119.489 84.6908 119.489Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M74.5099 88.8875C76.5183 88.8875 78.1463 87.2565 78.1463 85.2445C78.1463 83.2326 76.5183 81.6016 74.5099 81.6016C72.5016 81.6016 70.8735 83.2326 70.8735 85.2445C70.8735 87.2565 72.5016 88.8875 74.5099 88.8875Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M84.6908 88.8875C86.6992 88.8875 88.3272 87.2565 88.3272 85.2445C88.3272 83.2326 86.6992 81.6016 84.6908 81.6016C82.6825 81.6016 81.0544 83.2326 81.0544 85.2445C81.0544 87.2565 82.6825 88.8875 84.6908 88.8875Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M64.3273 129.688C66.3356 129.688 67.9637 128.057 67.9637 126.045C67.9637 124.033 66.3356 122.402 64.3273 122.402C62.319 122.402 60.6909 124.033 60.6909 126.045C60.6909 128.057 62.319 129.688 64.3273 129.688Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M94.8735 129.688C96.8818 129.688 98.5098 128.057 98.5098 126.045C98.5098 124.033 96.8818 122.402 94.8735 122.402C92.8651 122.402 91.2371 124.033 91.2371 126.045C91.2371 128.057 92.8651 129.688 94.8735 129.688Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M64.3273 109.286C66.3356 109.286 67.9637 107.655 67.9637 105.643C67.9637 103.631 66.3356 102 64.3273 102C62.319 102 60.6909 103.631 60.6909 105.643C60.6909 107.655 62.319 109.286 64.3273 109.286Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M74.5099 109.286C76.5183 109.286 78.1463 107.655 78.1463 105.643C78.1463 103.631 76.5183 102 74.5099 102C72.5016 102 70.8735 103.631 70.8735 105.643C70.8735 107.655 72.5016 109.286 74.5099 109.286Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M84.6908 109.286C86.6992 109.286 88.3272 107.655 88.3272 105.643C88.3272 103.631 86.6992 102 84.6908 102C82.6825 102 81.0544 103.631 81.0544 105.643C81.0544 107.655 82.6825 109.286 84.6908 109.286Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M94.8735 109.286C96.8818 109.286 98.5098 107.655 98.5098 105.643C98.5098 103.631 96.8818 102 94.8735 102C92.8651 102 91.2371 103.631 91.2371 105.643C91.2371 107.655 92.8651 109.286 94.8735 109.286Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M64.3273 99.0868C66.3356 99.0868 67.9637 97.4557 67.9637 95.4438C67.9637 93.4318 66.3356 91.8008 64.3273 91.8008C62.319 91.8008 60.6909 93.4318 60.6909 95.4438C60.6909 97.4557 62.319 99.0868 64.3273 99.0868Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M74.5099 99.0868C76.5183 99.0868 78.1463 97.4557 78.1463 95.4438C78.1463 93.4318 76.5183 91.8008 74.5099 91.8008C72.5016 91.8008 70.8735 93.4318 70.8735 95.4438C70.8735 97.4557 72.5016 99.0868 74.5099 99.0868Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M84.6908 99.0868C86.6992 99.0868 88.3272 97.4557 88.3272 95.4438C88.3272 93.4318 86.6992 91.8008 84.6908 91.8008C82.6825 91.8008 81.0544 93.4318 81.0544 95.4438C81.0544 97.4557 82.6825 99.0868 84.6908 99.0868Z",
    fill: "#FF2F57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M94.8735 99.0868C96.8818 99.0868 98.5098 97.4557 98.5098 95.4438C98.5098 93.4318 96.8818 91.8008 94.8735 91.8008C92.8651 91.8008 91.2371 93.4318 91.2371 95.4438C91.2371 97.4557 92.8651 99.0868 94.8735 99.0868Z",
    fill: "#FF2F57"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.e4364c6dc97ac97517226fd015e35282.svg";
export { ForwardRef as ReactComponent };